export const PremiumIcon = ({ fill = "#FFBB00", stroke = "#FFBB00" }) => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.9621 7.06745L13.0818 7.44425L10.9679 5.3262C10.7594 5.11736 10.4765 5 10.1814 5C9.88638 5 9.60343 5.11736 9.395 5.3262L7.28108 7.44425L5.40072 7.06745C5.0249 6.99215 4.63679 7.11586 4.37388 7.39478C4.11098 7.6737 4.01039 8.06843 4.10776 8.43915L5.61321 14.1711C5.74147 14.6594 6.18292 14.9999 6.68787 14.9999H13.675C14.1799 14.9999 14.6214 14.6594 14.7497 14.1711L16.2551 8.43912C16.3525 8.0684 16.2519 7.67368 15.989 7.39477C15.7261 7.11586 15.338 6.99215 14.9621 7.06745Z"
        fill={fill}
        stroke={stroke}
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const WhitePremiumIcon = () => {
  return (
    <svg
      width="12"
      height="10"
      viewBox="0 0 12 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.58513 2.80059L8.17487 3.08319L6.58942 1.49465C6.4331 1.33802 6.22089 1.25 5.9996 1.25C5.77831 1.25 5.5661 1.33802 5.40977 1.49465L3.82433 3.08319L2.41407 2.80059C2.1322 2.74411 1.84112 2.8369 1.64394 3.04609C1.44676 3.25527 1.37132 3.55132 1.44434 3.82936L2.57343 8.12829C2.66963 8.49458 3.00071 8.74995 3.37943 8.74996H8.61977C8.99849 8.74995 9.32957 8.49458 9.42577 8.12829L10.5549 3.82934C10.6279 3.5513 10.5524 3.25526 10.3552 3.04608C10.1581 2.8369 9.867 2.74411 9.58513 2.80059Z"
        fill="#F9F7F9"
        stroke="#F9F7F9"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AlertSuccess = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="2.1665"
        y="2.33008"
        width="15.3333"
        height="15.3333"
        rx="7.66667"
        fill="#027269"
      />
      <path
        d="M6.6665 10.2867L8.9553 12.5733L13.531 8"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SelectArrow = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.66699 8.33398L10.0003 11.6673L13.3337 8.33398"
        stroke="#4D4C4D"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DragIcon = (props) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="20" cy="20" r="20" fill="#672666" />
      <path
        d="M27.4999 22.5V25.8333C27.4999 26.2754 27.3243 26.6993 27.0118 27.0118C26.6992 27.3244 26.2753 27.5 25.8333 27.5H14.1666C13.7246 27.5 13.3007 27.3244 12.9881 27.0118C12.6755 26.6993 12.4999 26.2754 12.4999 25.8333V22.5M24.1666 16.6667L19.9999 12.5M19.9999 12.5L15.8333 16.6667M19.9999 12.5V22.5"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UploadIcon = (props) => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="36" height="36" rx="18" fill="white" />
      <path
        d="M24 18H12"
        stroke="#0A0A0A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 24V12"
        stroke="#0A0A0A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const BlueVerification = ({ fill = "#2E90FA" }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1994_24431)">
        <path
          d="M11.7664 3.53201C11.8978 3.84982 12.15 4.10244 12.4676 4.23433L13.5813 4.69564C13.8992 4.8273 14.1517 5.07982 14.2834 5.39765C14.415 5.71549 14.415 6.07261 14.2834 6.39044L13.8224 7.50336C13.6907 7.82134 13.6905 8.17882 13.8228 8.49664L14.283 9.60923C14.3482 9.76665 14.3818 9.93539 14.3819 10.1058C14.3819 10.2762 14.3483 10.445 14.2831 10.6024C14.2179 10.7598 14.1223 10.9029 14.0018 11.0234C13.8813 11.1439 13.7382 11.2394 13.5807 11.3046L12.4678 11.7656C12.15 11.897 11.8974 12.1492 11.7655 12.4668L11.3042 13.5805C11.1725 13.8984 10.92 14.1509 10.6022 14.2826C10.2843 14.4142 9.92722 14.4142 9.60938 14.2826L8.49647 13.8216C8.17862 13.6902 7.82163 13.6905 7.50398 13.8223L6.39027 14.283C6.07261 14.4143 5.7158 14.4142 5.39822 14.2827C5.08064 14.1511 4.82826 13.8989 4.69652 13.5814L4.23507 12.4673C4.10366 12.1495 3.85142 11.8969 3.5338 11.765L2.42009 11.3037C2.10239 11.1721 1.84994 10.9198 1.71824 10.6021C1.58654 10.2844 1.58636 9.92749 1.71775 9.60971L2.17873 8.49679C2.31006 8.17894 2.30979 7.82196 2.17799 7.50431L1.71766 6.38979C1.6524 6.23237 1.61879 6.06363 1.61876 5.89322C1.61874 5.72281 1.65229 5.55406 1.7175 5.39662C1.78272 5.23917 1.87832 5.09613 1.99883 4.97565C2.11935 4.85516 2.26243 4.75961 2.4199 4.69445L3.53281 4.23346C3.85035 4.10217 4.10282 3.85025 4.2348 3.533L4.69612 2.41928C4.82777 2.10144 5.08029 1.84892 5.39813 1.71727C5.71596 1.58562 6.07308 1.58562 6.39092 1.71727L7.50384 2.17826C7.82168 2.30959 8.17867 2.30932 8.49632 2.17751L9.61051 1.71799C9.9283 1.58641 10.2853 1.58643 10.6031 1.71806C10.9209 1.84969 11.1734 2.10213 11.305 2.41989L11.7665 3.53394L11.7664 3.53201Z"
          fill={fill}
        />
        <path
          d="M9.89062 6.06445C10.0639 5.95001 10.2996 5.96858 10.4521 6.12109L10.5088 6.19141C10.607 6.33999 10.6069 6.53398 10.5088 6.68262L10.4521 6.75293L7.50488 9.7002C7.23204 9.97304 6.79955 9.99068 6.50684 9.75195L6.4502 9.7002L5.44238 8.69141C5.26796 8.51699 5.26796 8.23496 5.44238 8.06055L5.51172 8.00293C5.68489 7.88848 5.92054 7.90733 6.07324 8.05957L6.97656 8.96191L9.82031 6.12109L9.89062 6.06445Z"
          fill="#F9F7F9"
          stroke="#F9F7F9"
          strokeWidth="0.298096"
        />
      </g>
      <defs>
        <clipPath id="clip0_1994_244312">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const GreenVerification = ({ fill = "#29BA07" }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1994_24710)">
        <path
          d="M11.7664 3.53201C11.8978 3.84982 12.15 4.10244 12.4676 4.23433L13.5813 4.69564C13.8992 4.8273 14.1517 5.07982 14.2834 5.39765C14.415 5.71549 14.415 6.07261 14.2834 6.39044L13.8224 7.50336C13.6907 7.82134 13.6905 8.17882 13.8228 8.49664L14.283 9.60923C14.3482 9.76665 14.3818 9.93539 14.3819 10.1058C14.3819 10.2762 14.3483 10.445 14.2831 10.6024C14.2179 10.7598 14.1223 10.9029 14.0018 11.0234C13.8813 11.1439 13.7382 11.2394 13.5807 11.3046L12.4678 11.7656C12.15 11.897 11.8974 12.1492 11.7655 12.4668L11.3042 13.5805C11.1725 13.8984 10.92 14.1509 10.6022 14.2826C10.2843 14.4142 9.92722 14.4142 9.60938 14.2826L8.49647 13.8216C8.17862 13.6902 7.82163 13.6905 7.50398 13.8223L6.39027 14.283C6.07261 14.4143 5.7158 14.4142 5.39822 14.2827C5.08064 14.1511 4.82826 13.8989 4.69652 13.5814L4.23507 12.4673C4.10366 12.1495 3.85142 11.8969 3.5338 11.765L2.42009 11.3037C2.10239 11.1721 1.84994 10.9198 1.71824 10.6021C1.58654 10.2844 1.58636 9.92749 1.71775 9.60971L2.17873 8.49679C2.31006 8.17894 2.30979 7.82196 2.17799 7.50431L1.71766 6.38979C1.6524 6.23237 1.61879 6.06363 1.61876 5.89322C1.61874 5.72281 1.65229 5.55406 1.7175 5.39662C1.78272 5.23917 1.87832 5.09613 1.99883 4.97565C2.11935 4.85516 2.26243 4.75961 2.4199 4.69445L3.53281 4.23346C3.85035 4.10217 4.10282 3.85025 4.2348 3.533L4.69612 2.41928C4.82777 2.10144 5.08029 1.84892 5.39813 1.71727C5.71596 1.58562 6.07308 1.58562 6.39092 1.71727L7.50384 2.17826C7.82168 2.30959 8.17867 2.30932 8.49632 2.17751L9.61051 1.71799C9.9283 1.58641 10.2853 1.58643 10.6031 1.71806C10.9209 1.84969 11.1734 2.10213 11.305 2.41989L11.7665 3.53394L11.7664 3.53201Z"
          fill={fill}
        />
        <path
          d="M9.89062 6.06445C10.0639 5.95001 10.2996 5.96858 10.4521 6.12109L10.5088 6.19141C10.607 6.33999 10.6069 6.53398 10.5088 6.68262L10.4521 6.75293L7.50488 9.7002C7.23204 9.97304 6.79955 9.99068 6.50684 9.75195L6.4502 9.7002L5.44238 8.69141C5.26796 8.51699 5.26796 8.23496 5.44238 8.06055L5.51172 8.00293C5.68489 7.88848 5.92054 7.90733 6.07324 8.05957L6.97656 8.96191L9.82031 6.12109L9.89062 6.06445Z"
          fill="#F9F7F9"
          stroke="#F9F7F9"
          strokeWidth="0.298096"
        />
      </g>
      <defs>
        <clipPath id="clip0_1994_24710w">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const BirthDay = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.99927 7.83333C1.99927 8.66176 2.67084 9.33333 3.49927 9.33333V9.33333C3.8972 9.33385 4.27892 9.17574 4.55993 8.894C4.8055 8.65853 5.19304 8.65853 5.4386 8.894C5.71962 9.17574 6.10134 9.33385 6.49927 9.33333V9.33333C6.8972 9.33385 7.27892 9.17574 7.55993 8.894C7.8055 8.65853 8.19304 8.65853 8.4386 8.894C8.71962 9.17574 9.10134 9.33385 9.49927 9.33333V9.33333C9.8972 9.33385 10.2789 9.17574 10.5599 8.894C10.8055 8.65853 11.193 8.65853 11.4386 8.894C11.7196 9.17574 12.1013 9.33385 12.4993 9.33333V9.33333C13.3277 9.33333 13.9993 8.66176 13.9993 7.83333V7.83333C13.9993 6.82081 13.1785 6 12.1659 6H3.8326C2.82008 6 1.99927 6.82081 1.99927 7.83333Z"
        stroke="#0A0A0A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6661 13.9993H1.33276"
        stroke="#0A0A0A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.66453 6.00192V4.66797"
        stroke="#0A0A0A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3344 6.00192V4.66797"
        stroke="#0A0A0A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.00242 6.00192V4.66797"
        stroke="#0A0A0A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.66453 2.66694V2"
        stroke="#0A0A0A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.00242 2.66694V2"
        stroke="#0A0A0A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3344 2.66694V2"
        stroke="#0A0A0A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3327 11.6673H2.66602"
        stroke="#0A0A0A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3331 13.9994V9.28516"
        stroke="#0A0A0A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.66536 13.9994V9.28516"
        stroke="#0A0A0A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ProfileId = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.66667 12.6654H4C2.89543 12.6654 2 11.7699 2 10.6654V5.33203C2 4.22746 2.89543 3.33203 4 3.33203H8.66667"
        stroke="#0A0A0A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.667 12.6654H12.0003C13.1049 12.6654 14.0003 11.7699 14.0003 10.6654V5.33203C14.0003 4.22746 13.1049 3.33203 12.0003 3.33203H10.667"
        stroke="#0A0A0A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6663 1.33203V14.6654"
        stroke="#0A0A0A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.66634 7.33203V8.66536"
        stroke="#0A0A0A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.33333 7.33203V8.66536"
        stroke="#0A0A0A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UserHeight = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.99976 6H13.3331C13.7013 6 13.9998 5.70152 13.9998 5.33333V2.66667C13.9998 2.29848 13.7013 2 13.3331 2H5.99976C3.79062 2 1.99976 3.79086 1.99976 6V10"
        stroke="#0A0A0A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="5.99976"
        cy="10"
        r="4"
        stroke="#0A0A0A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="5.99984"
        cy="10.0013"
        r="1.33333"
        stroke="#0A0A0A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.00008 2V3.33333"
        stroke="#0A0A0A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.00008 2V4"
        stroke="#0A0A0A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99984 2V3.33333"
        stroke="#0A0A0A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9996 2V4"
        stroke="#0A0A0A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const WhiteTick = ({ stroke = "white" }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.34961 9.9998L7.78419 14.4303L16.6496 5.56934"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Facebook = (props) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="#D9D7D9" />
      <path
        d="M18.7854 16.0052H16.9632V22.5H14.263C14.263 22.5 14.263 18.9512 14.263 16.0052H12.9795V13.7097H14.263V12.225C14.263 11.1616 14.7683 9.5 16.988 9.5L18.9889 9.50767V11.7359C18.9889 11.7359 17.773 11.7359 17.5366 11.7359C17.3002 11.7359 16.9641 11.8541 16.9641 12.3612V13.7102H19.0213L18.7854 16.0052Z"
        fill="#0A0A0A"
      />
    </svg>
  );
};

export const Instagram = (props) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="#D9D7D9" />
      <path
        d="M21.9672 13.528C21.9391 12.8904 21.836 12.4521 21.6883 12.0722C21.5359 11.6691 21.3015 11.3081 20.9944 11.008C20.6943 10.7033 20.3309 10.4665 19.9324 10.3165C19.5504 10.1688 19.1143 10.0657 18.4767 10.0375C17.8343 10.0071 17.6304 10 16.0012 10C14.372 10 14.168 10.0071 13.528 10.0352C12.8904 10.0633 12.4521 10.1665 12.0723 10.3141C11.6691 10.4665 11.3081 10.7009 11.008 11.008C10.7033 11.3081 10.4666 11.6714 10.3165 12.07C10.1688 12.4521 10.0657 12.8881 10.0375 13.5257C10.0071 14.168 10 14.372 10 16.0012C10 17.6304 10.0071 17.8343 10.0352 18.4743C10.0633 19.1119 10.1665 19.5503 10.3142 19.9301C10.4666 20.3333 10.7033 20.6943 11.008 20.9944C11.3081 21.2991 11.6714 21.5359 12.07 21.6859C12.4521 21.8336 12.8881 21.9367 13.5258 21.9648C14.1657 21.993 14.3697 22 15.9989 22C17.6281 22 17.8321 21.993 18.472 21.9648C19.1097 21.9367 19.548 21.8336 19.9278 21.6859C20.7342 21.3741 21.3718 20.7365 21.6836 19.9301C21.8312 19.548 21.9344 19.1119 21.9625 18.4743C21.9907 17.8343 21.9977 17.6304 21.9977 16.0012C21.9977 14.372 21.9953 14.168 21.9672 13.528ZM20.8866 18.4275C20.8608 19.0135 20.7623 19.33 20.6803 19.541C20.4786 20.0637 20.0637 20.4786 19.541 20.6803C19.33 20.7623 19.0112 20.8608 18.4275 20.8865C17.7945 20.9147 17.6047 20.9217 16.0036 20.9217C14.4025 20.9217 14.2102 20.9147 13.5796 20.8865C12.9935 20.8608 12.6771 20.7623 12.4661 20.6803C12.2059 20.5841 11.9691 20.4318 11.7769 20.2325C11.5777 20.0379 11.4253 19.8035 11.3292 19.5433C11.2471 19.3324 11.1487 19.0135 11.1229 18.4298C11.0947 17.7969 11.0878 17.607 11.0878 16.0059C11.0878 14.4047 11.0947 14.2125 11.1229 13.582C11.1487 12.9959 11.2471 12.6795 11.3292 12.4685C11.4253 12.2082 11.5777 11.9715 11.7793 11.7792C11.9738 11.58 12.2082 11.4276 12.4685 11.3315C12.6795 11.2495 12.9983 11.151 13.582 11.1252C14.2149 11.0971 14.4048 11.0901 16.0059 11.0901C17.6094 11.0901 17.7992 11.0971 18.4298 11.1252C19.0159 11.151 19.3324 11.2495 19.5433 11.3315C19.8035 11.4276 20.0403 11.58 20.2325 11.7792C20.4318 11.9738 20.5841 12.2082 20.6803 12.4685C20.7623 12.6795 20.8608 12.9982 20.8866 13.582C20.9147 14.2149 20.9218 14.4047 20.9218 16.0059C20.9218 17.607 20.9147 17.7945 20.8866 18.4275Z"
        fill="#0A0A0A"
      />
      <path
        d="M16.0016 12.918C14.2997 12.918 12.9189 14.2987 12.9189 16.0006C12.9189 17.7025 14.2997 19.0833 16.0016 19.0833C17.7035 19.0833 19.0842 17.7025 19.0842 16.0006C19.0842 14.2987 17.7035 12.918 16.0016 12.918ZM16.0016 18.0002C14.8975 18.0002 14.002 17.1048 14.002 16.0006C14.002 14.8964 14.8975 14.001 16.0016 14.001C17.1058 14.001 18.0012 14.8964 18.0012 16.0006C18.0012 17.1048 17.1058 18.0002 16.0016 18.0002Z"
        fill="#0A0A0A"
      />
      <path
        d="M19.9257 12.7978C19.9257 13.1952 19.6035 13.5174 19.206 13.5174C18.8086 13.5174 18.4863 13.1952 18.4863 12.7978C18.4863 12.4003 18.8086 12.0781 19.206 12.0781C19.6035 12.0781 19.9257 12.4003 19.9257 12.7978Z"
        fill="#0A0A0A"
      />
    </svg>
  );
};

export const Youtube = (props) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="#D9D7D9" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.6882 12.0478C21.2048 12.1861 21.6108 12.5921 21.7491 13.1087C21.999 14.0442 22 15.9971 22 15.9971C22 15.9971 22 17.95 21.7491 18.8855C21.6108 19.4021 21.2048 19.8081 20.6882 19.9463C19.7527 20.1973 16 20.1973 16 20.1973C16 20.1973 12.2473 20.1973 11.3118 19.9463C10.7952 19.8081 10.3892 19.4021 10.2509 18.8855C10 17.95 10 15.9971 10 15.9971C10 15.9971 10 14.0442 10.2509 13.1087C10.3892 12.5921 10.7952 12.1861 11.3118 12.0478C12.2473 11.7969 16 11.7969 16 11.7969C16 11.7969 19.7527 11.7969 20.6882 12.0478ZM17.9164 15.9972L14.7988 17.797V14.1974L17.9164 15.9972Z"
        fill="#0A0A0A"
      />
    </svg>
  );
};

export const SocialX = (props) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="#D9D7D9" />
      <path
        d="M17.117 15.0812L21.4882 10H20.4523L16.6568 14.4119L13.6254 10H10.1289L14.7131 16.6716L10.1289 22H11.1648L15.173 17.3409L18.3744 22H21.8709L17.1167 15.0812H17.117ZM15.6982 16.7304L15.2337 16.066L11.5381 10.7798H13.1291L16.1116 15.046L16.576 15.7103L20.4528 21.2557H18.8618L15.6982 16.7306V16.7304Z"
        fill="#0A0A0A"
      />
    </svg>
  );
};

export const GoogleColored = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1781_36580)">
        <path
          d="M4.93242 12.0855L4.23625 14.6845L1.69176 14.7383C0.931328 13.3279 0.5 11.7141 0.5 9.9993C0.5 8.34105 0.903281 6.7773 1.61812 5.40039H1.61867L3.88398 5.8157L4.87633 8.06742C4.66863 8.67293 4.55543 9.32293 4.55543 9.9993C4.55551 10.7334 4.68848 11.4367 4.93242 12.0855Z"
          fill="#FBBB00"
        />
        <path
          d="M20.3252 8.13184C20.44 8.73676 20.4999 9.36148 20.4999 9.99996C20.4999 10.7159 20.4246 11.4143 20.2812 12.0879C19.7944 14.3802 18.5224 16.3818 16.7604 17.7983L16.7598 17.7978L13.9065 17.6522L13.5027 15.1313C14.6719 14.4456 15.5857 13.3725 16.067 12.0879H10.7197V8.13184H16.145H20.3252Z"
          fill="#518EF8"
        />
        <path
          d="M16.7595 17.7984L16.7601 17.799C15.0464 19.1764 12.8694 20.0006 10.4996 20.0006C6.69141 20.0006 3.38043 17.8721 1.69141 14.7396L4.93207 12.0869C5.77656 14.3407 7.95074 15.9452 10.4996 15.9452C11.5952 15.9452 12.6216 15.649 13.5024 15.132L16.7595 17.7984Z"
          fill="#28B446"
        />
        <path
          d="M16.883 2.30219L13.6434 4.95437C12.7319 4.38461 11.6544 4.05547 10.5 4.05547C7.89344 4.05547 5.67859 5.73348 4.87641 8.06812L1.61871 5.40109H1.61816C3.28246 2.1923 6.6352 0 10.5 0C12.9264 0 15.1511 0.864297 16.883 2.30219Z"
          fill="#F14336"
        />
      </g>
      <defs>
        <clipPath id="clip0_1781_36580">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const BackArrow = ({ props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5 12H19"
        stroke="#4D4C4D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 7L5 12"
        stroke="#4D4C4D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 17L5 12"
        stroke="#4D4C4D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CloseIconPrimary = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="16" fill="#F2F2F2" />
      <path
        d="M20.523 11.6367L11.1514 21.0083"
        stroke="#1C1D1D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.523 21.0122L11.1514 11.6406"
        stroke="#1C1D1D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ModalSuccess = () => {
  return (
    <svg
      width="104"
      height="104"
      viewBox="0 0 104 104"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_dd_1802_25036)">
        <circle cx="52" cy="52" r="36" fill="#F9F7F9" />
        <circle
          cx="52"
          cy="52"
          r="36.9739"
          stroke="#B97AB7"
          strokeWidth="1.94787"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M68.6314 40.0625C69.5428 40.9739 69.5428 42.4517 68.6314 43.3631L48.6295 63.365C47.7182 64.2763 46.2407 64.2764 45.3292 63.3653L35.3241 53.3644C34.4124 52.4531 34.4121 50.9754 35.3234 50.0638C36.2346 49.1521 37.7123 49.1518 38.624 50.0631L46.9788 58.4144L65.3308 40.0625C66.2422 39.151 67.7199 39.151 68.6314 40.0625Z"
        fill="#963994"
      />
      <defs>
        <filter
          id="filter0_dd_1802_25036"
          x="3.82386"
          y="3.82239"
          width="96.3523"
          height="96.3552"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="3.89574"
            operator="dilate"
            in="SourceAlpha"
            result="effect1_dropShadow_1802_25036"
          />
          <feOffset />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.870588 0 0 0 0 0.690196 0 0 0 0 0.866667 0 0 0 0.62 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1802_25036"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="10.2284"
            operator="dilate"
            in="SourceAlpha"
            result="effect2_dropShadow_1802_25036"
          />
          <feOffset />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.870588 0 0 0 0 0.690196 0 0 0 0 0.866667 0 0 0 0.19 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_1802_25036"
            result="effect2_dropShadow_1802_25036"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_1802_25036"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const PrivacyIcon = (props) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.9996 42.4016C34.1616 42.4016 42.3996 34.1636 42.3996 24.0016C42.3996 13.8395 34.1616 5.60156 23.9996 5.60156C13.8376 5.60156 5.59961 13.8395 5.59961 24.0016C5.59961 34.1636 13.8376 42.4016 23.9996 42.4016Z"
        fill="url(#paint0_linear_1802_24853)"
      />
      <path
        d="M23.9996 43.4016C34.7139 43.4016 43.3996 34.7159 43.3996 24.0016C43.3996 13.2872 34.7139 4.60156 23.9996 4.60156C13.2853 4.60156 4.59961 13.2872 4.59961 24.0016C4.59961 34.7159 13.2853 43.4016 23.9996 43.4016Z"
        stroke="white"
        strokeOpacity="0.25"
        strokeWidth="2"
      />
      <path
        d="M22.457 31.0512C22.4186 31.0704 22.3802 31.0896 22.3354 31.1088C22.2522 31.1472 22.169 31.16 22.0794 31.16C21.9898 31.16 21.9066 31.1408 21.8234 31.1088C18.6746 29.7328 16.6394 26.6224 16.6394 23.1856V19.6784C16.6394 19.4288 16.7866 19.1984 17.017 19.096L21.817 16.9136C21.9834 16.8368 22.1754 16.8368 22.3482 16.9136L27.1482 19.096C27.3786 19.1984 27.5258 19.4288 27.5258 19.6784V20.8304C27.737 20.8112 27.9482 20.7984 28.1658 20.7984C28.7162 20.7984 29.2538 20.8752 29.7658 20.9968V18.2384C29.7658 17.9888 29.6186 17.7584 29.3882 17.656L22.3418 14.456C22.1754 14.3792 21.9834 14.3792 21.8106 14.456L14.777 17.656C14.5466 17.7584 14.3994 17.9888 14.3994 18.2384V23.1856C14.3994 27.5568 16.9978 31.4928 21.0234 33.2016L21.8298 33.5472C21.913 33.5792 21.9962 33.5984 22.0794 33.5984C22.1626 33.5984 22.2522 33.5792 22.329 33.5472L23.1354 33.2016C23.4298 33.0736 23.7178 32.9328 23.9994 32.7856C23.3914 32.2992 22.8666 31.7168 22.457 31.0512Z"
        fill="white"
      />
      <path
        d="M26.2399 21.0806V20.095L22.0799 18.207L17.9199 20.095V23.1862C17.9199 25.9126 19.4239 28.3958 21.7983 29.6694C21.5679 28.991 21.4399 28.2678 21.4399 27.519C21.4399 24.479 23.4687 21.9126 26.2399 21.0806Z"
        fill="white"
      />
      <path
        d="M28.1597 22.0781C25.1581 22.0781 22.7197 24.5165 22.7197 27.5181C22.7197 30.5197 25.1581 32.9581 28.1597 32.9581C31.1613 32.9581 33.5997 30.5197 33.5997 27.5181C33.5997 24.5165 31.1613 22.0781 28.1597 22.0781ZM30.7389 26.6413L28.1085 29.2973C27.9869 29.4189 27.8269 29.4893 27.6541 29.4893C27.4877 29.4893 27.3213 29.4189 27.1997 29.3037L25.5805 27.6845C25.3309 27.4349 25.3309 27.0317 25.5805 26.7757C25.8301 26.5261 26.2333 26.5261 26.4893 26.7757L27.6541 27.9405L29.8301 25.7453C30.0797 25.4957 30.4829 25.4893 30.7325 25.7453C30.9821 25.9949 30.9885 26.3981 30.7325 26.6477L30.7389 26.6413Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1802_24853"
          x1="33.8387"
          y1="7.7898"
          x2="14.5049"
          y2="42.4016"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB00" />
          <stop offset="1" stopColor="#F49129" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const StoriesIcon = (props) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.9996 42.4016C34.1616 42.4016 42.3996 34.1636 42.3996 24.0016C42.3996 13.8395 34.1616 5.60156 23.9996 5.60156C13.8376 5.60156 5.59961 13.8395 5.59961 24.0016C5.59961 34.1636 13.8376 42.4016 23.9996 42.4016Z"
        fill="url(#paint0_linear_1802_24863)"
      />
      <path
        d="M24 4.60156C34.7141 4.60177 43.3994 13.2878 43.3994 24.002C43.3992 34.716 34.714 43.4012 24 43.4014C13.2858 43.4014 4.59982 34.7161 4.59961 24.002C4.59961 13.2876 13.2857 4.60156 24 4.60156Z"
        stroke="white"
        strokeOpacity="0.25"
        strokeWidth="2"
      />
      <g clipPath="url(#clip0_1802_24863)">
        <path
          d="M16.001 21C17.6578 21 19.001 19.6569 19.001 18C19.001 16.3431 17.6578 15 16.001 15C14.3441 15 13.001 16.3431 13.001 18C13.001 19.6569 14.3441 21 16.001 21Z"
          fill="white"
        />
        <path
          d="M19.29 23.07C18.2835 23.6981 17.4534 24.5719 16.8778 25.6094C16.3023 26.6468 16.0002 27.8136 16 29H14C13.4701 28.9984 12.9623 28.7872 12.5875 28.4125C12.2128 28.0377 12.0016 27.5299 12 27V25C12.0024 24.2051 12.3192 23.4434 12.8813 22.8813C13.4434 22.3192 14.2051 22.0024 15 22H17C17.4366 22.001 17.8677 22.0972 18.2632 22.2821C18.6587 22.4669 19.0091 22.7358 19.29 23.07Z"
          fill="white"
        />
        <path
          d="M31.999 21C33.6559 21 34.999 19.6569 34.999 18C34.999 16.3431 33.6559 15 31.999 15C30.3422 15 28.999 16.3431 28.999 18C28.999 19.6569 30.3422 21 31.999 21Z"
          fill="white"
        />
        <path
          d="M36.0009 25V27C35.9994 27.5299 35.7881 28.0377 35.4134 28.4125C35.0387 28.7872 34.5309 28.9984 34.0009 29H32.0009C32.0008 27.8136 31.6987 26.6468 31.1231 25.6094C30.5475 24.5719 29.7174 23.6981 28.7109 23.07C28.9918 22.7358 29.3422 22.4669 29.7377 22.2821C30.1333 22.0972 30.5644 22.001 31.0009 22H33.0009C33.7959 22.0024 34.5575 22.3192 35.1196 22.8813C35.6817 23.4434 35.9986 24.2051 36.0009 25Z"
          fill="white"
        />
        <path
          d="M23.999 23C26.2082 23 27.999 21.2091 27.999 19C27.999 16.7909 26.2082 15 23.999 15C21.7899 15 19.999 16.7909 19.999 19C19.999 21.2091 21.7899 23 23.999 23Z"
          fill="white"
        />
        <path
          d="M30 29V30C29.9976 30.7949 29.6808 31.5566 29.1187 32.1187C28.5566 32.6808 27.7949 32.9976 27 33H21C20.2051 32.9976 19.4434 32.6808 18.8813 32.1187C18.3192 31.5566 18.0024 30.7949 18 30V29C18 27.6739 18.5268 26.4021 19.4645 25.4645C20.4021 24.5268 21.6739 24 23 24H25C26.3261 24 27.5979 24.5268 28.5355 25.4645C29.4732 26.4021 30 27.6739 30 29Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1802_24863"
          x1="33.8387"
          y1="7.7898"
          x2="14.5049"
          y2="42.4016"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB00" />
          <stop offset="1" stopColor="#F49129" />
        </linearGradient>
        <clipPath id="clip0_1802_24863">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(12 12)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const AIPowered = (props) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.9996 42.4016C34.1616 42.4016 42.3996 34.1636 42.3996 24.0016C42.3996 13.8395 34.1616 5.60156 23.9996 5.60156C13.8376 5.60156 5.59961 13.8395 5.59961 24.0016C5.59961 34.1636 13.8376 42.4016 23.9996 42.4016Z"
        fill="url(#paint0_linear_1802_24876)"
      />
      <path
        d="M24 4.60156C34.7141 4.60177 43.3994 13.2878 43.3994 24.002C43.3992 34.716 34.714 43.4012 24 43.4014C13.2858 43.4014 4.59982 34.7161 4.59961 24.002C4.59961 13.2876 13.2857 4.60156 24 4.60156Z"
        stroke="white"
        strokeOpacity="0.25"
        strokeWidth="2"
      />
      <path
        d="M21.9727 17.5785L22.575 19.251C23.244 21.1072 24.7057 22.569 26.562 23.238L28.2345 23.8402C28.3852 23.895 28.3852 24.1087 28.2345 24.1627L26.562 24.765C24.7057 25.434 23.244 26.8957 22.575 28.752L21.9727 30.4245C21.918 30.5752 21.7042 30.5752 21.6502 30.4245L21.048 28.752C20.379 26.8957 18.9172 25.434 17.061 24.765L15.3885 24.1627C15.2377 24.108 15.2377 23.8942 15.3885 23.8402L17.061 23.238C18.9172 22.569 20.379 21.1072 21.048 19.251L21.6502 17.5785C21.7042 17.427 21.918 17.427 21.9727 17.5785Z"
        fill="white"
      />
      <path
        d="M29.5003 13.5579L29.8055 14.4047C30.1445 15.3444 30.8848 16.0847 31.8245 16.4237L32.6713 16.7289C32.7478 16.7567 32.7478 16.8647 32.6713 16.8924L31.8245 17.1977C30.8848 17.5367 30.1445 18.2769 29.8055 19.2167L29.5003 20.0634C29.4725 20.1399 29.3645 20.1399 29.3368 20.0634L29.0315 19.2167C28.6925 18.2769 27.9523 17.5367 27.0125 17.1977L26.1658 16.8924C26.0893 16.8647 26.0893 16.7567 26.1658 16.7289L27.0125 16.4237C27.9523 16.0847 28.6925 15.3444 29.0315 14.4047L29.3368 13.5579C29.3645 13.4807 29.4733 13.4807 29.5003 13.5579Z"
        fill="white"
      />
      <path
        d="M29.5003 27.9363L29.8055 28.783C30.1445 29.7228 30.8848 30.463 31.8245 30.802L32.6713 31.1073C32.7478 31.135 32.7478 31.243 32.6713 31.2708L31.8245 31.576C30.8848 31.915 30.1445 32.6553 29.8055 33.595L29.5003 34.4418C29.4725 34.5183 29.3645 34.5183 29.3368 34.4418L29.0315 33.595C28.6925 32.6553 27.9523 31.915 27.0125 31.576L26.1658 31.2708C26.0893 31.243 26.0893 31.135 26.1658 31.1073L27.0125 30.802C27.9523 30.463 28.6925 29.7228 29.0315 28.783L29.3368 27.9363C29.3645 27.8598 29.4733 27.8598 29.5003 27.9363Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1802_24876"
          x1="33.8387"
          y1="7.7898"
          x2="14.5049"
          y2="42.4016"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB00" />
          <stop offset="1" stopColor="#F49129" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const RingIcon = (props) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.9996 42.4016C34.1616 42.4016 42.3996 34.1636 42.3996 24.0016C42.3996 13.8395 34.1616 5.60156 23.9996 5.60156C13.8376 5.60156 5.59961 13.8395 5.59961 24.0016C5.59961 34.1636 13.8376 42.4016 23.9996 42.4016Z"
        fill="url(#paint0_linear_1802_24886)"
      />
      <path
        d="M24 4.60156C34.7141 4.60177 43.3994 13.2878 43.3994 24.002C43.3992 34.716 34.714 43.4012 24 43.4014C13.2858 43.4014 4.59982 34.7161 4.59961 24.002C4.59961 13.2876 13.2857 4.60156 24 4.60156Z"
        stroke="white"
        strokeOpacity="0.25"
        strokeWidth="2"
      />
      <path
        d="M20.6247 33.5967C24.0111 33.5967 26.8125 30.8143 26.8125 27.3714C26.8125 26.4489 26.61 25.5825 26.25 24.7951C25.26 25.2226 24.5624 26.2126 24.5624 27.3714C24.5624 29.5218 22.8022 31.3466 20.6247 31.3466C18.4534 31.3466 16.687 29.5428 16.687 27.3714C16.687 25.2 18.4534 23.4337 20.6247 23.4337C20.8159 23.4337 21.0073 23.445 21.1985 23.4787C21.6485 22.7587 22.211 22.1286 22.8861 21.6111C22.1886 21.3411 21.4235 21.1836 20.6247 21.1836C17.2046 21.1836 14.3994 23.9513 14.3994 27.3714C14.3994 30.7915 17.2046 33.5967 20.6247 33.5967Z"
        fill="white"
      />
      <path
        d="M26.9691 15.0188C26.1518 14.2014 24.8295 14.192 23.9994 14.9891C23.1705 14.192 21.8476 14.2014 21.0297 15.0188C20.2023 15.8461 20.2023 17.1915 21.0297 18.0188L23.9994 21.026L26.9691 18.0188C27.7965 17.1914 27.7965 15.8461 26.9691 15.0188Z"
        fill="white"
      />
      <path
        d="M27.3743 31.3466C27.1831 31.3466 26.9918 31.3354 26.8006 31.3016C26.3506 32.0216 25.788 32.6517 25.113 33.1692C25.8105 33.4392 26.5755 33.5967 27.3743 33.5967C30.7945 33.5967 33.5996 30.7915 33.5996 27.3714C33.5996 23.9513 30.7945 21.1836 27.3743 21.1836C23.9776 21.1836 21.1865 23.9396 21.1865 27.3714C21.1865 28.2939 21.389 29.1978 21.7491 29.9852C22.7391 29.5577 23.4366 28.5302 23.4366 27.3714C23.4366 25.221 25.1969 23.4337 27.3743 23.4337C29.5457 23.4337 31.312 25.2 31.312 27.3714C31.312 29.5428 29.5457 31.3466 27.3743 31.3466Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1802_24886"
          x1="33.8387"
          y1="7.7898"
          x2="14.5049"
          y2="42.4016"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB00" />
          <stop offset="1" stopColor="#F49129" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const LikesIcon = ({ width = "16", height = "16" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="8" r="8" fill="#6DAE4F" fillOpacity="0.75" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.83366 6.95764V5.71904C8.83366 5.09573 8.43751 4.54132 7.84783 4.33937L7.68533 4.28372C7.52784 4.22978 7.35535 4.2409 7.20609 4.31461C7.05683 4.38831 6.94314 4.51852 6.89023 4.67635L6.12533 6.95815H4.64095C4.31015 6.95815 4.04199 7.22631 4.04199 7.55711V11.1509C4.04199 11.4817 4.31015 11.7498 4.64095 11.7498H10.1612C10.7109 11.7498 11.19 11.3757 11.3233 10.8424L11.9223 8.4466C12.0118 8.08874 11.9314 7.70961 11.7044 7.41885C11.4773 7.1281 11.129 6.95815 10.7602 6.95815H8.83366"
        fill="#C2E0B4"
      />
      <path
        d="M8.83366 6.95764V5.71904C8.83366 5.09573 8.43751 4.54132 7.84783 4.33937L7.68533 4.28372C7.52784 4.22978 7.35535 4.2409 7.20609 4.31461C7.05683 4.38831 6.94314 4.51852 6.89023 4.67635L6.12533 6.95815H4.64095C4.31015 6.95815 4.04199 7.22631 4.04199 7.55711V11.1509C4.04199 11.4817 4.31015 11.7498 4.64095 11.7498H10.1612C10.7109 11.7498 11.19 11.3757 11.3233 10.8424L11.9223 8.4466C12.0118 8.08874 11.9314 7.70961 11.7044 7.41885C11.4773 7.1281 11.129 6.95815 10.7602 6.95815H8.83366"
        stroke="#1E5611"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.12533 11.7507V6.95898V11.7507Z"
        fill="#C2E0B4"
      />
      <path
        d="M6.12533 11.7507V6.95898"
        stroke="#1E5611"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DislikesIcon = ({ width = "16", height = "16" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="8" r="8" fill="#CC4B4D" fillOpacity="0.65" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.16641 9.04218V10.2808C7.16641 10.9041 7.56256 11.4585 8.15225 11.6604L8.31474 11.7161C8.47223 11.77 8.64473 11.7589 8.79398 11.6852C8.94324 11.6115 9.05693 11.4813 9.10984 11.3235L9.87474 9.04167H11.3591C11.6899 9.04167 11.9581 8.7735 11.9581 8.44271V4.84896C11.9581 4.51816 11.6899 4.25 11.3591 4.25H5.83888C5.28919 4.25 4.81005 4.62411 4.67673 5.15738L4.07777 7.55321C3.9883 7.91108 4.0687 8.29021 4.29572 8.58096C4.52273 8.87172 4.87104 9.04167 5.23992 9.04167H7.16641"
        fill="#E0B4B4"
      />
      <path
        d="M7.16641 9.04218V10.2808C7.16641 10.9041 7.56256 11.4585 8.15224 11.6604L8.31474 11.7161C8.47223 11.77 8.64473 11.7589 8.79398 11.6852C8.94324 11.6115 9.05693 11.4813 9.10984 11.3235L9.87474 9.04167H11.3591C11.6899 9.04167 11.9581 8.7735 11.9581 8.44271V4.84896C11.9581 4.51816 11.6899 4.25 11.3591 4.25H5.83888C5.28919 4.25 4.81005 4.62411 4.67673 5.15738L4.07777 7.55321C3.9883 7.91108 4.0687 8.29021 4.29572 8.58096C4.52273 8.87172 4.87104 9.04167 5.23992 9.04167H7.16641"
        stroke="#561112"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.87484 4.25V9.04167V4.25Z"
        fill="#E0B4B4"
      />
      <path
        d="M9.87484 4.25V9.04167"
        stroke="#561112"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Comments = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10" cy="10" r="10" fill="#2E90FA" fillOpacity="0.65" />
      <path
        d="M13.5918 5.80078H6.0918L5.4668 10.0008L6.0918 11.8008L8.5918 12.4008V14.2008H9.2168L10.4668 12.4008H13.5918L14.8418 11.2008V7.60078L13.5918 5.80078Z"
        fill="#B3D8FF"
      />
      <path
        d="M8.50586 14.5007L11.11 12.4902"
        stroke="#034A96"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.50456 12.502V14.502"
        stroke="#034A96"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.50586 12.5H7.98503C6.54701 12.5 5.38086 11.3805 5.38086 10V8C5.38086 6.6195 6.54701 5.5 7.98503 5.5H12.1517C13.5897 5.5 14.7559 6.6195 14.7559 8V10C14.7559 11.3805 13.5897 12.5 12.1517 12.5H11.11"
        stroke="#034A96"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const CircleTick = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10" cy="10.9199" r="10" fill="#672666" fillOpacity="0.1" />
      <path
        d="M7.03223 10.6137L9.01106 12.5907L12.9671 8.63672"
        stroke="#672666"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PicCount = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.49805 3.49888C1.49805 2.39385 2.39385 1.49805 3.49888 1.49805H8.50096C9.60599 1.49805 10.5018 2.39385 10.5018 3.49888V8.50096C10.5018 9.60599 9.60599 10.5018 8.50096 10.5018H3.49888C2.39385 10.5018 1.49805 9.60599 1.49805 8.50096V3.49888Z"
        stroke="#0A0A0A"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 7.99995L8.29396 5.70599C8.68462 5.31545 9.31788 5.31545 9.70854 5.70599L10.5019 6.49932"
        stroke="#0A0A0A"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="3.74836"
        cy="3.74836"
        r="0.750312"
        stroke="#0A0A0A"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.67383 9.32285L3.78971 7.20697C4.18037 6.81643 4.81364 6.81643 5.2043 7.20697L8.41414 10.4168"
        stroke="#0A0A0A"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Message = ({ stroke = "#4D4C4D" }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 17.5002L11.6667 14.1494"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.49967 14.167V17.5003"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 14.1667H6.66667C4.36583 14.1667 2.5 12.3008 2.5 10V6.66667C2.5 4.36583 4.36583 2.5 6.66667 2.5H13.3333C15.6342 2.5 17.5 4.36583 17.5 6.66667V10C17.5 12.3008 15.6342 14.1667 13.3333 14.1667H11.6667"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Cancel = ({ stroke = "#4D4C4D" }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.4987 4.5L4.50195 15.4967"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.4987 15.4997L4.50195 4.50293"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Favourite = ({ fill = "white", stroke = "#383738" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0004 7.1805C12.5572 6.52918 13.5204 5.79785 14.9871 5.79785C17.552 5.79785 19.2732 8.20597 19.2732 10.4484C19.2732 15.1362 13.4372 18.7273 12.0004 18.7273C10.5636 18.7273 4.72754 15.1362 4.72754 10.4484C4.72754 8.20597 6.44878 5.79785 9.01367 5.79785C10.4804 5.79785 11.4436 6.52918 12.0004 7.1805Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AiRecommendation = () => {
  return (
    <svg
      width="25"
      height="23"
      viewBox="0 0 25 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 12.3849C7.39286 12.3849 10.6154 9.27461 10.6154 1.76953C10.6154 9.27461 13.8152 12.3849 21.2308 12.3849C13.8152 12.3849 10.6154 15.5847 10.6154 23.0003C10.6154 15.5847 7.39286 12.3849 0 12.3849Z"
        fill="url(#paint0_linear_2227_23608)"
      />
      <path
        d="M15.0381 4.86538C18.4265 4.86538 19.9035 3.43983 19.9035 0C19.9035 3.43983 21.37 4.86538 24.7689 4.86538C21.37 4.86538 19.9035 6.33195 19.9035 9.73077C19.9035 6.33195 18.4265 4.86538 15.0381 4.86538Z"
        fill="url(#paint1_linear_2227_23608)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2227_23608"
          x1="10.4172"
          y1="22.7349"
          x2="20.2082"
          y2="1.84757"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#963994" />
          <stop offset="1" stopColor="#F7A7F5" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2227_23608"
          x1="19.8126"
          y1="9.60915"
          x2="24.3002"
          y2="0.0357691"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#963994" />
          <stop offset="1" stopColor="#F7A7F5" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const RightArrow = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 15L12.5 10L7.5 5"
        stroke="#672666"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SearchIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z"
        stroke="#4D4C4D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.0025 14.0016L11.1025 11.1016L14.0025 14.0016Z"
        fill="#6B6A6B"
      />
      <path
        d="M14.0025 14.0016L11.1025 11.1016"
        stroke="#6B6A6B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ShareIcon = () => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.42977 6.74342C7.12412 7.43777 7.12412 8.56354 6.42977 9.25789C5.73542 9.95225 4.60965 9.95225 3.9153 9.25789C3.22094 8.56354 3.22094 7.43777 3.9153 6.74342C4.60965 6.04907 5.73542 6.04907 6.42977 6.74342"
        stroke="#0A0A0A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5401 3.18678C14.2345 3.88113 14.2345 5.0069 13.5401 5.70125C12.8458 6.39561 11.72 6.39561 11.0256 5.70125C10.3313 5.0069 10.3313 3.88113 11.0256 3.18678C11.72 2.49243 12.8458 2.49243 13.5401 3.18678"
        stroke="#0A0A0A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5401 10.2981C14.2345 10.9925 14.2345 12.1182 13.5401 12.8126C12.8458 13.5069 11.72 13.5069 11.0256 12.8126C10.3313 12.1182 10.3313 10.9925 11.0256 10.2981C11.72 9.60376 12.8458 9.60376 13.5401 10.2981"
        stroke="#0A0A0A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.75391 7.20576L10.7006 5.23242"
        stroke="#0A0A0A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.75391 8.79297L10.7006 10.7663"
        stroke="#0A0A0A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AlertError = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="2.1665"
        y="2.33008"
        width="15.3333"
        height="15.3333"
        rx="7.66667"
        fill="#D31510"
      />
      <path
        d="M6.6665 6.6665L13.3332 13.3332"
        stroke="white"
        strokeWidth="1"
        strokeLinecap="round"
      />
      <path
        d="M6.6665 13.3332L13.3332 6.6665"
        stroke="white"
        strokeWidth="1"
        strokeLinecap="round"
      />
    </svg>
  );
};
export const AlertInfo = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="9.99971"
        cy="10.0012"
        r="7.50312"
        fill="#699EF3"
        stroke="#699EF3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.16602 12.9188H11.0913"
        stroke="#699EF3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.1326 12.9181V9.375H9.17383"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0833 6.87192C10.0833 6.98703 9.98996 7.08034 9.87485 7.08034C9.75974 7.08034 9.66643 6.98703 9.66643 6.87192C9.66643 6.75681 9.75974 6.6635 9.87485 6.6635"
        stroke="#699EF3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.87464 6.66419C9.98975 6.66419 10.0831 6.75751 10.0831 6.87261"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const AlertWarning = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.691 3.44867L18.0735 14.6187C18.8151 15.917 17.8776 17.5328 16.3826 17.5328H3.61763C2.12179 17.5328 1.18429 15.917 1.92679 14.6187L8.30929 3.44867C9.05679 2.13951 10.9435 2.13951 11.691 3.44867Z"
        fill="#F3B917"
        stroke="#F3B917"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0002 10.9331V7.81641"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99933 13.4368C9.88433 13.4368 9.791 13.5302 9.79183 13.6452C9.79183 13.7602 9.88517 13.8535 10.0002 13.8535C10.1152 13.8535 10.2085 13.7602 10.2085 13.6452C10.2085 13.5302 10.1152 13.4368 9.99933 13.4368"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const StepperActive = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_1802_25666)">
        <g clipPath="url(#clip0_1802_25666)">
          <rect x="6" y="6" width="20" height="20" rx="10" fill="#B3D6D2" />
          <rect
            x="6.68326"
            y="6.68326"
            width="18.6335"
            height="18.6335"
            rx="9.31674"
            fill="#963894"
          />
          <rect
            x="6.68326"
            y="6.68326"
            width="18.6335"
            height="18.6335"
            rx="9.31674"
            stroke="#DEB0DD"
            strokeWidth="1.36651"
          />
          <circle cx="16" cy="16" r="4" fill="#FFCD00" />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_1802_25666"
          x="2.87654"
          y="2.87654"
          width="26.2469"
          height="26.2469"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="3.12346"
            operator="dilate"
            in="SourceAlpha"
            result="effect1_dropShadow_1802_25666"
          />
          <feOffset />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.788235 0 0 0 0 0.458824 0 0 0 0 0.784314 0 0 0 0.24 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1802_25666"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1802_25666"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_1802_25666">
          <rect x="6" y="6" width="20" height="20" rx="10" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const StepperInactive = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="6.5" y="6.5" width="19" height="19" rx="9.5" fill="#DEB0DD" />
      <rect x="6.5" y="6.5" width="19" height="19" rx="9.5" stroke="#DEB0DD" />
      <circle cx="16" cy="16" r="8" fill="#672666" />
    </svg>
  );
};

export const StepperFilled = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1802_25935)">
        <rect x="6" y="6" width="20" height="20" rx="10" fill="#B3D6D2" />
        <rect
          x="6.68326"
          y="6.68326"
          width="18.6335"
          height="18.6335"
          rx="9.31674"
          fill="#963894"
        />
        <rect
          x="6.68326"
          y="6.68326"
          width="18.6335"
          height="18.6335"
          rx="9.31674"
          stroke="#672666"
          strokeWidth="1.36651"
        />
        <path
          d="M12.439 15.9994L14.8136 18.3717L19.5608 13.627"
          stroke="#FFCD00"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1802_25935">
          <rect x="6" y="6" width="20" height="20" rx="10" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const AddIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1802_27685)">
        <path
          d="M6 0C6.19891 0 6.38968 0.0790178 6.53033 0.21967C6.67098 0.360322 6.75 0.551088 6.75 0.75V5.25H11.25C11.4489 5.25 11.6397 5.32902 11.7803 5.46967C11.921 5.61032 12 5.80109 12 6C12 6.19891 11.921 6.38968 11.7803 6.53033C11.6397 6.67098 11.4489 6.75 11.25 6.75H6.75V11.25C6.75 11.4489 6.67098 11.6397 6.53033 11.7803C6.38968 11.921 6.19891 12 6 12C5.80109 12 5.61032 11.921 5.46967 11.7803C5.32902 11.6397 5.25 11.4489 5.25 11.25V6.75H0.75C0.551088 6.75 0.360322 6.67098 0.21967 6.53033C0.0790178 6.38968 0 6.19891 0 6C0 5.80109 0.0790178 5.61032 0.21967 5.46967C0.360322 5.32902 0.551088 5.25 0.75 5.25H5.25V0.75C5.25 0.551088 5.32902 0.360322 5.46967 0.21967C5.61032 0.0790178 5.80109 0 6 0Z"
          fill="#4B4B4B"
        />
      </g>
      <defs>
        <clipPath id="clip0_1802_27685">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const WritingIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M3 17.05H18V2.05H3V17.05Z" fill="black" />
    </svg>
  );
};

export const MenuIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.69">
        <rect
          width="24"
          height="24"
          rx="12"
          transform="matrix(-1 0 0 1 24 0)"
          fill="#0A0A0A"
        />
        <path
          d="M12.1816 8.4375C12.8375 8.4375 13.3691 7.90584 13.3691 7.25C13.3691 6.59416 12.8375 6.0625 12.1816 6.0625C11.5258 6.0625 10.9941 6.59416 10.9941 7.25C10.9941 7.90584 11.5258 8.4375 12.1816 8.4375Z"
          fill="white"
        />
        <path
          d="M12.1816 13.1875C12.8375 13.1875 13.3691 12.6558 13.3691 12C13.3691 11.3442 12.8375 10.8125 12.1816 10.8125C11.5258 10.8125 10.9941 11.3442 10.9941 12C10.9941 12.6558 11.5258 13.1875 12.1816 13.1875Z"
          fill="white"
        />
        <path
          d="M12.1816 17.9375C12.8375 17.9375 13.3691 17.4058 13.3691 16.75C13.3691 16.0942 12.8375 15.5625 12.1816 15.5625C11.5258 15.5625 10.9941 16.0942 10.9941 16.75C10.9941 17.4058 11.5258 17.9375 12.1816 17.9375Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export const UploadModalIcon = () => {
  return (
    <svg
      width="104"
      height="104"
      viewBox="0 0 104 104"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_dd_1802_27034)">
        <circle cx="52" cy="52" r="36" fill="#F9F7F9" />
        <circle
          cx="52"
          cy="52"
          r="36.9739"
          stroke="#B97AB7"
          strokeWidth="1.94787"
        />
      </g>
      <circle cx="52" cy="52" r="20" fill="#F9F7F9" />
      <path
        d="M62.208 54.291V58.4577C62.208 59.0102 61.9885 59.5401 61.5978 59.9308C61.2071 60.3215 60.6772 60.541 60.1247 60.541H45.5413C44.9888 60.541 44.4589 60.3215 44.0682 59.9308C43.6775 59.5401 43.458 59.0102 43.458 58.4577V54.291M58.0413 46.9993L52.833 41.791M52.833 41.791L47.6247 46.9993M52.833 41.791V54.291"
        stroke="#963994"
        strokeWidth="2.23958"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <filter
          id="filter0_dd_1802_27034"
          x="3.82386"
          y="3.82434"
          width="96.3523"
          height="96.3513"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="3.89574"
            operator="dilate"
            in="SourceAlpha"
            result="effect1_dropShadow_1802_27034"
          />
          <feOffset />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.870588 0 0 0 0 0.690196 0 0 0 0 0.866667 0 0 0 0.62 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1802_27034"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="10.2284"
            operator="dilate"
            in="SourceAlpha"
            result="effect2_dropShadow_1802_27034"
          />
          <feOffset />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.870588 0 0 0 0 0.690196 0 0 0 0 0.866667 0 0 0 0.19 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_1802_27034"
            result="effect2_dropShadow_1802_27034"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_1802_27034"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const VisibleFaceIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="12"
        cy="9.5"
        r="2.5"
        stroke="#0A0A0A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 18V17C7 15.6193 8.11929 14.5 9.5 14.5H14.5C15.8807 14.5 17 15.6193 17 17V18"
        stroke="#0A0A0A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 11V20C21 21.1046 20.1046 22 19 22H5C3.89543 22 3 21.1046 3 20V5C3 3.89543 3.89543 3 5 3H13"
        stroke="#0A0A0A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 18H3"
        stroke="#0A0A0A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.342 2.39018C18.4735 2.14961 18.7258 2 19 2C19.2742 2 19.5265 2.14961 19.6581 2.39018L20.2427 3.45918C20.3115 3.58505 20.415 3.68853 20.5408 3.75736L21.6098 4.34196C21.8504 4.4735 22 4.72583 22 5.00001C22 5.27419 21.8504 5.52652 21.6098 5.65806L20.5408 6.24266C20.415 6.31149 20.3115 6.41497 20.2427 6.54084L19.6581 7.60984C19.5265 7.85041 19.2742 8.00002 19 8.00002C18.7258 8.00002 18.4735 7.85041 18.342 7.60984L17.7574 6.54084C17.6885 6.41497 17.585 6.31149 17.4592 6.24266L16.3902 5.65806C16.1496 5.52652 16 5.27419 16 5.00001C16 4.72583 16.1496 4.4735 16.3902 4.34196L17.4592 3.75736C17.585 3.68853 17.6885 3.58505 17.7574 3.45918L18.342 2.39018Z"
        stroke="#0A0A0A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SoloPhotoIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 21H5C3.895 21 3 20.105 3 19V5C3 3.895 3.895 3 5 3H19C20.105 3 21 3.895 21 5V19C21 20.105 20.105 21 19 21Z"
        stroke="#0A0A0A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1213 7.87868C15.2929 9.05025 15.2929 10.9497 14.1213 12.1213C12.9497 13.2929 11.0502 13.2929 9.87868 12.1213C8.70711 10.9497 8.70711 9.05025 9.87868 7.87868C11.0502 6.70711 12.9497 6.70711 14.1213 7.87868"
        stroke="#0A0A0A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 21L6.357 19.216C6.731 17.346 8.372 16 10.279 16H13.721C15.628 16 17.269 17.346 17.643 19.216L18 21"
        stroke="#0A0A0A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const GalleryIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="3"
        y="3"
        width="18"
        height="18"
        rx="5"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.9084 15.9942L18.2071 13.2929C17.8165 12.9024 17.1834 12.9024 16.7928 13.2929L14.5 15.5858L10.2071 11.2929C9.81654 10.9024 9.18337 10.9024 8.79285 11.2929L3.3125 16.7732"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.3227 8.32383L14.3231 8.32339C14.4206 8.22387 14.5803 8.22218 14.6799 8.31962C14.7795 8.41705 14.7813 8.57675 14.6839 8.67639C14.5865 8.77603 14.4268 8.77791 14.3271 8.6806C14.2274 8.58328 14.2255 8.42359 14.3227 8.32383"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ImageResolutionIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.7793 6.99609H9.22097C7.99328 6.99609 6.99805 7.99133 6.99805 9.21902V14.7773C6.99805 16.005 7.99328 17.0003 9.22097 17.0003H14.7793C16.007 17.0003 17.0022 16.005 17.0022 14.7773V9.21802C17.0017 7.99072 16.0066 6.99609 14.7793 6.99609Z"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5095 10.1553C10.5812 10.2268 10.6028 10.3344 10.5641 10.428C10.5254 10.5215 10.4342 10.5826 10.333 10.5826C10.2317 10.5826 10.1405 10.5215 10.1018 10.428C10.0632 10.3344 10.0847 10.2268 10.1564 10.1553C10.2031 10.1083 10.2667 10.0819 10.333 10.0819C10.3992 10.0819 10.4628 10.1083 10.5095 10.1553"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.0022 11.4995C16.7703 11.4643 16.5363 11.4456 16.3019 11.4435C14.8883 11.4335 13.5414 12.044 12.6173 13.1137C11.6931 14.1834 11.2847 15.6046 11.4999 17.0018"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0015 21.0038H17.0023C19.2124 21.0038 21.004 19.2122 21.004 17.0021V15.6016"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.39859 2.99609H6.998C4.78795 2.99609 2.99634 4.7877 2.99634 6.99776V8.39834"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.99634 15.6016V17.0021C2.99634 19.2122 4.78795 21.0038 6.998 21.0038H8.39859"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.004 8.39834V6.99776C21.004 4.7877 19.2124 2.99609 17.0023 2.99609H15.0015"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const NavNotification = () => {
  return (
    <svg
      width="25"
      height="26"
      viewBox="0 0 25 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1816 19.8476C17.8209 19.8476 20.4297 19.1242 20.6816 16.2205C20.6816 13.3188 18.8628 13.5054 18.8628 9.94511C18.8628 7.16414 16.2269 4 12.1816 4C8.13641 4 5.50049 7.16414 5.50049 9.94511C5.50049 13.5054 3.68164 13.3188 3.68164 16.2205C3.93459 19.1352 6.54341 19.8476 12.1816 19.8476Z"
        stroke="#0A0A0A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5705 22.8574C13.2064 24.3721 11.0784 24.3901 9.70117 22.8574"
        stroke="#0A0A0A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const CrownIcon = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.9621 7.06745L13.0818 7.44425L10.9679 5.3262C10.7594 5.11736 10.4765 5 10.1814 5C9.88638 5 9.60343 5.11736 9.395 5.3262L7.28108 7.44425L5.40072 7.06745C5.0249 6.99215 4.63679 7.11586 4.37388 7.39478C4.11098 7.6737 4.01039 8.06843 4.10776 8.43915L5.61321 14.1711C5.74147 14.6594 6.18292 14.9999 6.68787 14.9999H13.675C14.1799 14.9999 14.6214 14.6594 14.7497 14.1711L16.2551 8.43912C16.3525 8.0684 16.2519 7.67368 15.989 7.39477C15.7261 7.11586 15.338 6.99215 14.9621 7.06745Z"
        fill="#FFBB00"
        stroke="#FFBB00"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const CrownWhiteIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        transform="translate(-2, -2)"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.9621 7.06745L13.0818 7.44425L10.9679 5.3262C10.7594 5.11736 10.4765 5 10.1814 5C9.88638 5 9.60343 5.11736 9.395 5.3262L7.28108 7.44425L5.40072 7.06745C5.0249 6.99215 4.63679 7.11586 4.37388 7.39478C4.11098 7.6737 4.01039 8.06843 4.10776 8.43915L5.61321 14.1711C5.74147 14.6594 6.18292 14.9999 6.68787 14.9999H13.675C14.1799 14.9999 14.6214 14.6594 14.7497 14.1711L16.2551 8.43912C16.3525 8.0684 16.2519 7.67368 15.989 7.39477C15.7261 7.11586 15.338 6.99215 14.9621 7.06745Z"
        fill="#FFFFFF"
        stroke="#323232"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const CloseIcon = ({ stroke = "#0A0A0A" }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3305 2.66663L2.66699 13.3301"
        stroke={stroke}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3305 13.3333L2.66699 2.6698"
        stroke={stroke}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const BookmarkIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.3332 4V13.3321C13.3332 13.5846 13.1905 13.8154 12.9647 13.9283C12.7389 14.0413 12.4686 14.017 12.2666 13.8655L7.99984 10.6667L3.73307 13.8655C3.53105 14.017 3.2608 14.0413 3.03497 13.9283C2.80915 13.8154 2.6665 13.5846 2.6665 13.3321V4C2.6665 2.89543 3.56193 2 4.6665 2H11.3332C12.4377 2 13.3332 2.89543 13.3332 4Z"
        fill="#0A0A0A"
        stroke="#0A0A0A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ClockIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.70461 2.45797C8.76527 1.18997 12.2739 2.64397 13.5419 5.70464C14.8099 8.76531 13.3559 12.274 10.2953 13.542C7.23461 14.81 3.72594 13.356 2.45794 10.2953C1.19061 7.23464 2.64394 3.72597 5.70461 2.45797"
        stroke="#4D4C4D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.81201 5.32324V8.42391L10.2493 9.90991"
        stroke="#4D4C4D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const HeaderSearchIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_5330_5765)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.93 8.35839C16.1108 9.96582 15.6797 11.629 14.6367 12.9705L17.0196 15.3535C17.331 15.6649 17.331 16.1698 17.0196 16.4813C16.7082 16.7927 16.2032 16.7927 15.8918 16.4813L13.5089 14.0984C11.0145 16.0381 7.40755 15.8618 5.11531 13.5696C2.63214 11.0864 2.63214 7.0604 5.11531 4.57723C6.78382 2.90872 9.1489 2.36132 11.2745 2.93503C11.1675 2.99617 11.0549 3.04888 10.9376 3.09228L10.0999 3.40224C9.61618 3.58124 9.29446 3.92948 9.13479 4.33357C8.07907 4.43913 7.05187 4.89628 6.24312 5.70503C4.38281 7.56534 4.38281 10.5815 6.24312 12.4418C8.08407 14.2828 11.0569 14.3019 12.9215 12.4993C12.9386 12.4782 12.957 12.4578 12.9766 12.4382C12.9962 12.4186 13.0165 12.4003 13.0376 12.3831C13.6785 11.7201 14.0891 10.917 14.2693 10.0744C14.8682 10.0287 15.4449 9.66933 15.694 8.99625L15.93 8.35839Z"
          fill="white"
        />
      </g>
      <g filter="url(#filter1_d_5330_5765)">
        <path
          d="M13.9891 1.43966C14.0402 1.30136 14.2358 1.30136 14.287 1.43966L14.597 2.27731C14.9777 3.30633 15.7891 4.11766 16.8181 4.49843L17.6557 4.80839C17.794 4.85956 17.794 5.05517 17.6557 5.10634L16.8181 5.4163C15.7891 5.79707 14.9777 6.6084 14.597 7.63743L14.287 8.47507C14.2358 8.61337 14.0402 8.61337 13.9891 8.47507L13.6791 7.63743C13.2983 6.6084 12.487 5.79708 11.458 5.4163L10.6203 5.10634C10.482 5.05517 10.482 4.85956 10.6203 4.80839L11.458 4.49843C12.487 4.11766 13.2983 3.30633 13.6791 2.27731L13.9891 1.43966Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_5330_5765"
          x="2.75293"
          y="2.71484"
          width="15.0005"
          height="15.5"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="0.25" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0392157 0 0 0 0 0.0392157 0 0 0 0 0.0392157 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_5330_5765"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5330_5765"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_5330_5765"
          x="10.0166"
          y="1.33594"
          width="8.24268"
          height="8.74219"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="0.25" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0392157 0 0 0 0 0.0392157 0 0 0 0 0.0392157 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_5330_5765"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5330_5765"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const HamburgerIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 6H21.9808M3 11.875H21.9808M3 17.75H21.9808"
        stroke="#0A0A0A"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  );
};
export const HeartIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 5.711C12.689 4.905 13.881 4 15.696 4C18.871 4 21 6.98 21 9.755C21 15.556 13.778 20 12 20C10.222 20 3 15.556 3 9.755C3 6.98 5.129 4 8.304 4C10.119 4 11.311 4.905 12 5.711Z"
        stroke="#963894"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const TickCircle = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.75"
        y="0.75"
        width="18.5"
        height="18.5"
        rx="9.25"
        stroke="#963894"
        strokeWidth="1.5"
      />
      <path
        d="M6.25 10L8.75 12.5L13.75 7.5"
        stroke="#963894"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const NotificationCalender = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.5 1V4"
        stroke="#963894"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5 1V4"
        stroke="#963894"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="1"
        y="2.5"
        width="18"
        height="16.5"
        rx="3"
        stroke="#963894"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="5"
        y="11"
        width="4"
        height="4"
        rx="1"
        stroke="#963894"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const NotificationStory = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.5 6L16 9L12.5 6L13.375 4H18.625L19.5 6Z"
        stroke="#963894"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.74156 9.25931C7.03116 8.43128 4.11039 9.60699 2.72954 12.0819C1.34869 14.5568 1.88218 17.6598 4.01033 19.5314C6.13847 21.403 9.28419 21.5357 11.5624 19.85C13.8406 18.1643 14.6336 15.1172 13.466 12.5348"
        stroke="#963894"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.2583 20.7395C16.9687 21.5675 19.8894 20.3918 21.2703 17.9169C22.6511 15.442 22.1176 12.339 19.9895 10.4674C17.8613 8.5958 14.7156 8.4631 12.4374 10.1488C10.1592 11.8345 9.36626 14.8816 10.5338 17.464"
        stroke="#963894"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const LogoutIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.1401 12H4.00014"
        stroke="#4D4C4D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.1362 19.981L17.3042 20C18.4992 20.006 19.4712 19.048 19.4712 17.865V6.135C19.4712 4.956 18.5062 4 17.3142 4H13.0002"
        stroke="#4D4C4D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 16L4 12L8 8"
        stroke="#4D4C4D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AccountIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 20.0001C5 17.5001 7 15.6001 9.4 15.6001H14.5C17 15.6001 18.9 17.6001 18.9 20.0001"
        stroke="#4D4C4D"
        strokeWidth="1.4824"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 5.2C16.7 6.9 16.7 9.6 15 11.2C13.3 12.8 10.6 12.9 8.99999 11.2C7.39999 9.5 7.29999 6.8 8.99999 5.2C10.7 3.6 13.3 3.6 15 5.2"
        stroke="#4D4C4D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ActivityLogIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 12H17"
        stroke="#4D4C4D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        width="18"
        height="18"
        rx="4"
        transform="matrix(1 0 0 -1 3 21)"
        stroke="#4D4C4D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 16H17"
        stroke="#4D4C4D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 8H12"
        stroke="#4D4C4D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ReferIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.4749 4.52513C15.8417 5.89197 15.8417 8.10804 14.4749 9.47488C13.108 10.8417 10.892 10.8417 9.52513 9.47488C8.15829 8.10804 8.15829 5.89197 9.52513 4.52513C10.892 3.15829 13.108 3.15829 14.4749 4.52513"
        stroke="#4D4C4D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 18.4998V19.4998C4 20.0518 4.448 20.4998 5 20.4998H19C19.552 20.4998 20 20.0518 20 19.4998V18.4998C20 15.4738 16.048 13.5078 12 13.5078C7.952 13.5078 4 15.4738 4 18.4998Z"
        stroke="#4D4C4D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const TermsIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 9V5C20 3.89543 19.1046 3 18 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H10"
        stroke="#4D4C4D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 8H16"
        stroke="#4D4C4D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 16H10"
        stroke="#4D4C4D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 12H14"
        stroke="#4D4C4D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.9714 17.2L18.7321 12.4393C19.3179 11.8536 20.2676 11.8536 20.8534 12.4393L21.5605 13.1464C22.1463 13.7322 22.1463 14.682 21.5605 15.2678L16.7998 20.0285C16.4173 20.411 15.9211 20.6591 15.3856 20.7356L13.5707 20.9949C13.4149 21.0171 13.2577 20.9647 13.1465 20.8535C13.0352 20.7422 12.9828 20.585 13.005 20.4292L13.2643 18.6143C13.3408 18.0788 13.5889 17.5826 13.9714 17.2Z"
        stroke="#4D4C4D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.2088 16.6194L17.3804 13.791"
        stroke="#4D4C4D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const FeedbackIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.666 2.00001C9.279 1.99501 6.156 3.82801 4.509 6.78801C2.862 9.74801 2.951 13.369 4.741 16.244L3 21L7.755 19.259C11.119 21.344 15.433 21.08 18.517 18.599C21.601 16.118 22.784 11.961 21.468 8.22801C20.153 4.49401 16.624 1.99801 12.666 2.00001V2.00001Z"
        stroke="#4D4C4D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.496 8C15.994 8 17 9.397 17 10.698C17 13.338 12.826 15.5 12.75 15.5C12.674 15.5 8.5 13.338 8.5 10.698C8.5 9.397 9.506 8 11.004 8C11.861 8 12.424 8.424 12.75 8.802C13.075 8.424 13.638 8 14.496 8Z"
        stroke="#4D4C4D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const WeddingStoriesIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.0642 7H5.93622C5.40922 7 4.97322 7.408 4.93822 7.933L4.14222 19.867C4.06522 21.021 4.98122 22 6.13822 22H17.8622C19.0192 22 19.9352 21.021 19.8582 19.867L19.0622 7.933C19.0272 7.408 18.5912 7 18.0642 7Z"
        stroke="#0A0A0A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.001 9V5V5V5C15.001 3.343 13.658 2 12.001 2H12C10.343 2 9 3.343 9 5V5V5V9"
        stroke="#0A0A0A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 13.535C12.23 13.283 12.627 13 13.232 13C14.29 13 15 13.931 15 14.798C15 16.611 12.593 18 12 18C11.407 18 9 16.611 9 14.798C9 13.931 9.71 13 10.768 13C11.373 13 11.77 13.283 12 13.535Z"
        stroke="#0A0A0A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const SuccessStoriesIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.30034 17.2857L11.1359 19.7337C11.5679 20.3097 12.4319 20.3097 12.8639 19.7337L14.6994 17.2857H17.7599C19.3506 17.2857 20.6399 15.9965 20.6399 14.4057V5.76574C20.6399 4.17502 19.3506 2.88574 17.7599 2.88574H6.23986C4.64914 2.88574 3.35986 4.17502 3.35986 5.76574V14.4057C3.35986 15.9965 4.64914 17.2857 6.23986 17.2857H9.30034Z"
        stroke="#0A0A0A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9999 7.54783C12.3426 7.16095 12.9359 6.72607 13.8392 6.72607C15.4203 6.72607 16.4802 8.15551 16.4802 9.48799C16.4802 12.272 12.8859 14.4061 11.9999 14.4061C11.1138 14.4061 7.51953 12.272 7.51953 9.48799C7.51953 8.15551 8.57937 6.72607 10.1605 6.72607C11.0639 6.72607 11.6571 7.16095 11.9999 7.54783Z"
        stroke="#0A0A0A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const BlogIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 10H13.5"
        stroke="#0A0A0A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 4V20C4 21.105 4.895 22 6 22H18C19.105 22 20 21.105 20 20V6.828C20 6.298 19.789 5.789 19.414 5.414L16.586 2.586C16.211 2.211 15.702 2 15.172 2H6C4.895 2 4 2.895 4 4Z"
        stroke="#0A0A0A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 6H10.5"
        stroke="#0A0A0A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.027 14.333C11.909 14.333 12.5 15.109 12.5 15.832C12.5 17.299 10.045 18.5 10 18.5C9.955 18.5 7.5 17.299 7.5 15.832C7.5 15.109 8.092 14.333 8.973 14.333C9.477 14.333 9.808 14.569 10 14.779C10.191 14.569 10.523 14.333 11.027 14.333Z"
        stroke="#0A0A0A"
        strokeWidth="1.5625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 7H16C14.895 7 14 6.105 14 5V2"
        stroke="#0A0A0A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const SettingsIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.909 10.0906C14.9634 11.145 14.9634 12.8546 13.909 13.909C12.8546 14.9634 11.145 14.9634 10.0906 13.909C9.0362 12.8546 9.0362 11.145 10.0906 10.0906C11.145 9.0362 12.8546 9.0362 13.909 10.0906"
        stroke="#4D4C4D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.24987 12C5.24987 12.297 5.27687 12.594 5.31287 12.882L3.72487 14.124C3.37287 14.4 3.27687 14.893 3.50087 15.28L4.91287 17.723C5.13587 18.11 5.60987 18.273 6.02487 18.107L7.44687 17.536C7.72787 17.423 8.04087 17.468 8.29287 17.635C8.51287 17.781 8.74087 17.915 8.97687 18.035C9.24687 18.172 9.44287 18.417 9.48587 18.717L9.70287 20.23C9.76587 20.672 10.1449 21 10.5909 21H13.4079C13.8539 21 14.2329 20.672 14.2959 20.23L14.5129 18.718C14.5559 18.418 14.7539 18.171 15.0249 18.035C15.2599 17.917 15.4869 17.784 15.7059 17.639C15.9599 17.471 16.2739 17.423 16.5559 17.537L17.9749 18.107C18.3889 18.273 18.8629 18.11 19.0869 17.723L20.4989 15.28C20.7229 14.893 20.6269 14.399 20.2749 14.124L18.6869 12.882C18.7229 12.594 18.7499 12.297 18.7499 12C18.7499 11.703 18.7229 11.406 18.6869 11.118L20.2749 9.876C20.6269 9.6 20.7229 9.107 20.4989 8.72L19.0869 6.277C18.8639 5.89 18.3899 5.727 17.9749 5.893L16.5559 6.463C16.2739 6.576 15.9599 6.529 15.7059 6.361C15.4869 6.216 15.2599 6.083 15.0249 5.965C14.7539 5.829 14.5559 5.582 14.5129 5.282L14.2969 3.77C14.2339 3.328 13.8549 3 13.4089 3H10.5919C10.1459 3 9.76687 3.328 9.70387 3.77L9.48587 5.284C9.44287 5.583 9.24587 5.829 8.97687 5.966C8.74087 6.086 8.51287 6.221 8.29287 6.366C8.03987 6.532 7.72687 6.577 7.44587 6.464L6.02487 5.893C5.60987 5.727 5.13587 5.89 4.91287 6.277L3.50087 8.72C3.27687 9.107 3.37287 9.601 3.72487 9.876L5.31287 11.118C5.27687 11.406 5.24987 11.703 5.24987 12V12Z"
        stroke="#4D4C4D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EditIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.293 15.6185L15.619 5.2925C16.009 4.9025 16.642 4.9025 17.032 5.2925L18.708 6.9685C19.098 7.3585 19.098 7.9915 18.708 8.3815L8.381 18.7065C8.194 18.8945 7.94 18.9995 7.675 18.9995H5V16.3245C5 16.0595 5.105 15.8055 5.293 15.6185Z"
        stroke="#6B6A6B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.75 7.16016L16.84 10.2502"
        stroke="#6B6A6B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const MatchTickIcon = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.0908203" width="20" height="20" rx="10" fill="#963994" />
      <path
        d="M6.34082 10L8.84082 12.5L13.8408 7.5"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LoveMatchIcon = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_1802_36501)">
        <rect
          x="2.34668"
          y="0.730469"
          width="42.5666"
          height="42.5666"
          rx="21.2833"
          fill="white"
          shapeRendering="crispEdges"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.0272 18.0498C26.3857 17.0722 26.5125 16.0647 26.2796 15.1009C25.7655 13.0038 23.5647 11.1524 21.0849 11.7507C19.6704 12.0966 18.8991 13.0073 18.5152 13.7371C17.8235 13.2552 16.7283 12.8044 15.3126 13.1503C12.8317 13.7497 11.7065 16.3932 12.2207 18.4902C12.9793 21.6387 17.3947 23.4521 19.7084 24.1726"
          fill="#FF7373"
        />
        <path
          d="M26.0272 18.0499C26.3857 17.0722 26.5125 16.0647 26.2796 15.1009C25.7655 13.0038 23.5647 11.1524 21.0849 11.7507C19.6704 12.0966 18.8991 13.0073 18.5152 13.7371C17.8235 13.2552 16.7283 12.8044 15.3126 13.1503C12.8317 13.7497 11.7065 16.3932 12.2207 18.4902C12.9793 21.6387 17.3947 23.4521 19.7084 24.1726"
          stroke="#FF7373"
          strokeWidth="1.96205"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M32.9056 21.9707C35.3773 23.4544 35.6908 26.6939 34.4331 28.7852C31.8911 33.0207 22.93 32.3763 22.8066 32.306"
          stroke="#D71F1F"
          strokeWidth="1.96205"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M29.262 21.5394C29.089 20.6159 28.5622 19.3778 27.1592 18.5293"
          stroke="#D71F1F"
          strokeWidth="1.96205"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M29.249 21.5428C30.1448 21.2546 31.4855 21.1277 32.9001 21.9797"
          stroke="#D71F1F"
          strokeWidth="1.96205"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M27.1535 18.5268C24.6818 17.0431 21.6706 18.2951 20.4244 20.3898C17.8789 24.6357 22.6736 32.2353 22.8084 32.309"
          stroke="#D71F1F"
          strokeWidth="1.96205"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M27.1556 18.965L29.0314 22.0132L30.2038 21.5443L32.5486 22.2477L34.4244 23.8891L34.8933 26.2338L34.4244 29.0476L32.5486 30.9234L28.0935 32.5647L23.404 33.0337L21.9971 32.3302L20.1213 27.6407L19.6523 24.1235L20.8247 20.1374L23.1695 18.4961L27.1556 18.965Z"
          fill="#D71F1F"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1802_36501"
          x="0.21835"
          y="0.730469"
          width="46.8231"
          height="46.8232"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2.12833" />
          <feGaussianBlur stdDeviation="1.06416" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1802_36501"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1802_36501"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const CarouselLeftIcon = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.59082"
        y="0.5"
        width="23"
        height="23"
        rx="11.5"
        stroke="#DBDAD8"
      />
      <path
        d="M8.21582 12.1375L15.7158 12.1375"
        stroke="#0A0A0A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.2402 15.1493L8.21523 12.1373L11.2402 9.12485"
        stroke="#0A0A0A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CarouselRightIcon = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.59082"
        y="0.5"
        width="23"
        height="23"
        rx="11.5"
        stroke="#DBDAD8"
      />
      <path
        d="M15.9658 11.8625H8.46582"
        stroke="#0A0A0A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.9414 8.85065L15.9664 11.8627L12.9414 14.8752"
        stroke="#0A0A0A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PreviousArrowIcon = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5908 16L6.59082 12L10.5908 8"
        stroke="#0A0A0A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5908 17L12.5908 12L17.5908 7"
        stroke="#0A0A0A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CarouselPreviousArrow = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        className="carousel-arrow-svg"
        x="0.59082"
        y="0.5"
        width="23"
        height="23"
        rx="11.5"
        stroke="#DBDAD8"
      />
      <path
        d="M8.21582 12.1375L15.7158 12.1375"
        stroke="#0A0A0A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.2402 15.1493L8.21523 12.1373L11.2402 9.12485"
        stroke="#0A0A0A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ThreeDotMenu = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0226 18.242C12.0778 18.242 12.1225 18.2822 12.1225 18.3317C12.1224 18.3813 12.0777 18.4214 12.0225 18.4214C11.9673 18.4215 11.9225 18.3814 11.9225 18.3318C11.9224 18.308 11.933 18.2851 11.9517 18.2683C11.9705 18.2514 11.996 18.242 12.0226 18.242"
        stroke="#0A0A0A"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0226 5.67949C12.0778 5.67955 12.1225 5.71972 12.1225 5.76925C12.1224 5.81878 12.0777 5.85893 12.0225 5.85895C11.9673 5.85897 11.9225 5.81885 11.9225 5.76932C11.9224 5.74549 11.933 5.72262 11.9518 5.70577C11.9705 5.68892 11.996 5.67946 12.0226 5.67949"
        stroke="#0A0A0A"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0226 11.9607C12.0778 11.9608 12.1225 12.001 12.1225 12.0505C12.1224 12.1 12.0777 12.1402 12.0225 12.1402C11.9673 12.1402 11.9225 12.1001 11.9225 12.0506C11.9224 12.0267 11.933 12.0039 11.9518 11.987C11.9705 11.9702 11.996 11.9607 12.0226 11.9607"
        stroke="#0A0A0A"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LockIcon = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4238 14.5001H4.75716C4.02049 14.5001 3.42383 13.9034 3.42383 13.1667V8.50008C3.42383 7.76341 4.02049 7.16675 4.75716 7.16675H11.4238C12.1605 7.16675 12.7572 7.76341 12.7572 8.50008V13.1667C12.7572 13.9034 12.1605 14.5001 11.4238 14.5001Z"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.42383 7.16667V5.16667V5.16667C5.42383 3.694 6.61783 2.5 8.09049 2.5V2.5C9.56316 2.5 10.7572 3.694 10.7572 5.16667V5.16667V7.16667"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const HelpIcon = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.59082 14.5V14.5C5.27682 14.5 2.59082 11.814 2.59082 8.5V8.5C2.59082 5.186 5.27682 2.5 8.59082 2.5V2.5C11.9048 2.5 14.5908 5.186 14.5908 8.5V8.5C14.5908 11.814 11.9048 14.5 8.59082 14.5Z"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.59115 9.33399V9.16732C8.59115 8.62266 8.92781 8.32732 9.26515 8.10066C9.59448 7.87866 9.92448 7.58932 9.92448 7.05599C9.92448 6.31932 9.32781 5.72266 8.59115 5.72266C7.85448 5.72266 7.25781 6.31932 7.25781 7.05599"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.59048 11.1667C8.49848 11.1667 8.42381 11.2413 8.42448 11.3333C8.42448 11.4253 8.49915 11.5 8.59115 11.5C8.68315 11.5 8.75781 11.4253 8.75781 11.3333C8.75781 11.2413 8.68315 11.1667 8.59048 11.1667"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const WhatsAppIcon = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 22.5C4.45 22.5 3.979 22.3043 3.587 21.913C3.19567 21.521 3 21.05 3 20.5V6.5H5V20.5H16V22.5H5ZM9 18.5C8.45 18.5 7.97933 18.3043 7.588 17.913C7.196 17.521 7 17.05 7 16.5V4.5C7 3.95 7.196 3.479 7.588 3.087C7.97933 2.69567 8.45 2.5 9 2.5H18C18.55 2.5 19.021 2.69567 19.413 3.087C19.8043 3.479 20 3.95 20 4.5V16.5C20 17.05 19.8043 17.521 19.413 17.913C19.021 18.3043 18.55 18.5 18 18.5H9Z"
        fill="#672666"
      />
    </svg>
  );
};

export const ActiveLogIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.14355 11.4141H12.4184"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.14355 13.3164H14.3763"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.14355 3.41406H12.4184"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.14355 5.31641H14.3763"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="3.81051"
        cy="4.36715"
        r="2.18746"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="3.81051"
        cy="12.3671"
        r="2.18746"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.81055 7.05859V9.6988"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const FavouriteDouble = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0285 6.39427C8.60622 5.54053 6.87353 6.26094 6.15644 7.46626C4.69175 9.9094 7.45065 14.2822 7.52826 14.3247"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3393 8.37695C14.7616 9.23069 14.942 11.0947 14.2183 12.2981C12.7556 14.7352 7.5993 14.3644 7.52832 14.3239"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.2393 8.12655C11.1398 7.59521 10.8366 6.88276 10.0293 6.39453"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.2383 8.12591C11.7537 7.96007 12.5252 7.8871 13.3391 8.37732"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.3808 6.05735C9.5871 5.49483 9.66007 4.91505 9.52608 4.36049C9.23022 3.15384 7.96387 2.08849 6.53699 2.43278C5.72306 2.63178 5.27927 3.15583 5.05837 3.57574C4.66036 3.29846 4.03017 3.03908 3.21557 3.23809C1.78803 3.58304 1.14059 5.10411 1.43645 6.31075C1.87294 8.12238 4.41359 9.16584 5.74495 9.58044"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ReferSecondary = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5957 14.589C2.5957 12.6452 4.15071 11.168 6.01671 11.168H8.98197"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7657 13.5449L15.0996 12.211L13.7657 10.8771"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.426 14.8789H11.759C11.0221 14.8789 10.4251 14.282 10.4251 13.545V13.545C10.4251 12.808 11.0221 12.2111 11.759 12.2111H15.0938"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3705 3.08144C11.6923 4.40319 11.6923 6.50244 10.3705 7.74645C9.0488 8.99045 6.94954 9.0682 5.70554 7.74645C4.46154 6.42469 4.38379 4.32544 5.70554 3.08144C7.02729 1.83744 9.0488 1.83744 10.3705 3.08144"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const LockIconFill = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_1802_29733)">
        <path
          d="M17.75 10.0566H17.1667V7.80664C17.1667 5.32489 15.0737 3.30664 12.5 3.30664C9.92633 3.30664 7.83333 5.32489 7.83333 7.80664V10.0566H7.25C6.28556 10.0566 5.5 10.8134 5.5 11.7441V19.6191C5.5 20.5499 6.28556 21.3066 7.25 21.3066H17.75C18.7144 21.3066 19.5 20.5499 19.5 19.6191V11.7441C19.5 10.8134 18.7144 10.0566 17.75 10.0566ZM9.38889 7.80664C9.38889 6.15214 10.7842 4.80664 12.5 4.80664C14.2158 4.80664 15.6111 6.15214 15.6111 7.80664V10.0566H9.38889V7.80664ZM13.2778 15.8481V17.5566C13.2778 17.9706 12.9301 18.3066 12.5 18.3066C12.0699 18.3066 11.7222 17.9706 11.7222 17.5566V15.8481C11.2594 15.5879 10.9444 15.1094 10.9444 14.5566C10.9444 13.7294 11.6421 13.0566 12.5 13.0566C13.3579 13.0566 14.0556 13.7294 14.0556 14.5566C14.0556 15.1094 13.7406 15.5879 13.2778 15.8481Z"
          fill="#0A0A0A"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1802_29733"
          x="5.5"
          y="3.30664"
          width="14"
          height="19.5"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1802_29733"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1802_29733"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const ExploreMyMatches = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00006 4.30537C8.60935 3.5735 9.5155 3.15447 10.4678 3.16423C12.582 3.16423 14.0026 5.15172 14.0026 7.00249C14.0026 10.8714 9.18589 13.8353 8.00006 13.8353C6.81423 13.8353 1.99756 10.8714 1.99756 7.00249C1.99756 5.15172 3.41815 3.16423 5.53236 3.16423C6.48462 3.15447 7.39076 3.5735 8.00006 4.30537Z"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.23621 7.54883L7.69157 9.09481L6.76318 8.16575"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ExploreNearMe = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.7711 4.06536V4.06536C13.8539 6.158 13.8539 9.54041 11.7711 11.633V11.633L9.56319 13.8483C8.70384 14.7117 7.30727 14.715 6.44386 13.8557L6.43652 13.8483L4.22859 11.6331C2.14582 9.54041 2.14581 6.15803 4.22855 4.06536V4.06536C6.30154 1.98257 9.67047 1.97461 11.7533 4.0476L11.771 4.06536H11.7711Z"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.17327 6.57998C8.74882 6.0168 9.67195 6.02682 10.2351 6.60237V6.60237C10.8107 7.19042 10.8107 8.13066 10.2351 8.71871L8.82514 10.1504L8.80743 10.1681C8.35182 10.6139 7.62106 10.606 7.17523 10.1504L5.76516 8.7187C5.18961 8.13065 5.18961 7.19042 5.76516 6.60238V6.60238L5.78753 6.58C6.06391 6.30954 6.43642 6.15995 6.82309 6.16415C7.20977 6.16835 7.57894 6.32598 7.84939 6.60238L8.00015 6.75542L8.15089 6.60236L8.17327 6.57998Z"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ExploreLatest = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.3277 9.47617L3.12469 10.5193L3.29677 11.8178C3.39214 12.5381 3.95838 13.105 4.67868 13.2011L5.98055 13.3751L7.02298 14.1715C7.59989 14.6123 8.39956 14.6123 8.97646 14.1715L10.0196 13.3745H10.0182L11.3174 13.2024C12.0377 13.107 12.6046 12.5408 12.7007 11.8205L12.8741 10.5186C12.8741 10.5193 13.2769 9.99172 13.6711 9.47617C14.1119 8.89926 14.1113 8.09959 13.6711 7.52269L12.8761 6.47825L12.704 5.17971C12.6086 4.45941 12.0424 3.89251 11.3221 3.79647L10.0196 3.62306L8.97713 2.82673C8.40022 2.38588 7.60056 2.38588 7.02365 2.82673L5.98055 3.62373H5.98188L4.68201 3.79647C3.96171 3.89184 3.39481 4.45808 3.29877 5.17838L3.12469 6.47959C3.12469 6.47892 2.72186 7.00647 2.3277 7.52202C1.88751 8.09826 1.88751 8.89926 2.3277 9.47617Z"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.87894 6.83203C9.63392 6.83203 10.1401 7.51498 10.1401 8.15125C10.1401 9.48113 8.42342 10.5002 7.99991 10.5002C7.5764 10.5002 5.86035 9.48113 5.86035 8.15125C5.86035 7.51498 6.36656 6.83203 7.12154 6.83203C7.55306 6.83203 7.83584 7.03945 8.00058 7.22486C8.16464 7.03945 8.44743 6.83203 8.87894 6.83203Z"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ExplorePremium = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4839 10.6024L11.3332 10.7554L11.1824 10.6024C10.9081 10.3221 10.5325 10.1641 10.1403 10.1641C9.7481 10.1641 9.37246 10.3221 9.09817 10.6024V10.6024C8.52262 11.1904 8.52262 12.1306 9.09817 12.7187L10.5082 14.1504C10.7254 14.3723 11.0227 14.4974 11.3332 14.4974C11.6436 14.4974 11.941 14.3723 12.1581 14.1504L13.5682 12.7187C14.1437 12.1307 14.1437 11.1904 13.5682 10.6024V10.6024C13.2939 10.3221 12.9182 10.1641 12.526 10.1641C12.1338 10.1641 11.7582 10.3221 11.4839 10.6024Z"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66667 10.498H4.66667C3.19391 10.498 2 11.692 2 13.1647V13.8314"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="7.33317"
        cy="5.16471"
        r="2.66667"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ExploreRecommended = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 14.4974H2.66667C2.29867 14.4974 2 14.1987 2 13.8307V9.83073C2 9.46273 2.29867 9.16406 2.66667 9.16406H4C4.368 9.16406 4.66667 9.46273 4.66667 9.83073V13.8307C4.66667 14.1987 4.368 14.4974 4 14.4974Z"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.6665 11.8308H10.2218C10.5105 11.8308 10.7912 11.7374 11.0218 11.5641L12.6325 10.3561C13.0345 10.0548 13.5972 10.0948 13.9525 10.4501V10.4501C14.3472 10.8448 14.3472 11.4841 13.9525 11.8781L12.5705 13.2601C12.1985 13.6321 11.7238 13.8861 11.2078 13.9894L9.2545 14.3801C8.86717 14.4574 8.46784 14.4481 8.0845 14.3521L6.31784 13.9108C6.1065 13.8574 5.88984 13.8308 5.67184 13.8308H4.6665"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.6665 11.8307H9.6565C10.2145 11.8307 10.6665 11.3787 10.6665 10.8207V10.6187C10.6665 10.1554 10.3512 9.7514 9.90184 9.6394L8.37384 9.2574C8.12517 9.1954 7.8705 9.16406 7.6145 9.16406V9.16406C6.9965 9.16406 6.39184 9.34673 5.87784 9.69006L4.6665 10.4974"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5925 2.84517C13.5698 2.98717 14.1005 3.9425 13.9838 4.74384C13.7478 6.36984 10.8325 7.30517 10.7832 7.2985C10.7338 7.29117 8.20582 5.5645 8.44182 3.93917C8.55848 3.13784 9.33848 2.37317 10.3158 2.51517C10.8745 2.5965 11.2038 2.91117 11.3818 3.1745C11.6285 2.97184 12.0338 2.76384 12.5925 2.84517V2.84517Z"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ExploreMoreMatches = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 6.49935H2"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 10.4993H2"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.66683 8.49935H1.3335"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.2124 4.25754C4.92839 2.54155 7.5091 2.02821 9.75114 2.9569C11.9932 3.88558 13.455 6.0734 13.455 8.50018C13.455 10.9269 11.9932 13.1148 9.75114 14.0435C7.5091 14.9721 4.92839 14.4588 3.2124 12.7428"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.01039 7.28432C8.52839 6.76445 9.35921 6.7737 9.86608 7.30498V7.30498C10.3841 7.8478 10.3841 8.71573 9.86608 9.25854L8.59708 10.5801L8.58114 10.5965C8.17109 11.008 7.5134 11.0007 7.11216 10.5801L5.84309 9.25854C5.32509 8.71572 5.32509 7.84781 5.84309 7.30499V7.30499L5.86322 7.28434C6.11197 7.03468 6.44722 6.8966 6.79523 6.90047C7.14324 6.90434 7.47549 7.04986 7.7189 7.30499L7.85459 7.44626L7.99025 7.30498L8.01039 7.28432Z"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const FilterIcon = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.76776 4.56426C7.74407 5.54057 7.74407 7.12349 6.76776 8.0998C5.79146 9.0761 4.20854 9.0761 3.23223 8.0998C2.25592 7.12349 2.25592 5.54057 3.23223 4.56426C4.20854 3.58795 5.79146 3.58795 6.76776 4.56426"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6667 6.33073H7.5"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.7678 12.8963C17.7441 13.8726 17.7441 15.4555 16.7678 16.4318C15.7915 17.4081 14.2085 17.4081 13.2322 16.4318C12.2559 15.4555 12.2559 13.8726 13.2322 12.8963C14.2085 11.92 15.7915 11.92 16.7678 12.8963"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33398 14.6667H12.5007"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const GridIcon = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 6.5H10.6667V11.1667H6V6.5Z"
        stroke="#0A0A0A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.3335 6.5H18.0002V11.1667H13.3335V6.5Z"
        stroke="#0A0A0A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 13.832H10.6667V18.4987H6V13.832Z"
        stroke="#0A0A0A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.333 13.832H17.9997V18.4987H13.333V13.832Z"
        stroke="#0A0A0A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ListIcon = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 15.7939C17.1871 15.794 17.3667 15.8677 17.499 16L17.5869 16.1074C17.6637 16.2225 17.7051 16.3586 17.7051 16.499C17.7051 16.6394 17.6637 16.7756 17.5869 16.8906L17.499 16.998C17.3667 17.1303 17.1871 17.205 17 17.2051H7C6.8596 17.2051 6.72349 17.1627 6.6084 17.0859L6.50098 16.998C6.36866 16.8657 6.29395 16.6861 6.29395 16.499C6.29397 16.3119 6.36868 16.1323 6.50098 16L6.6084 15.9121C6.72347 15.8354 6.85964 15.7939 7 15.7939H17ZM17 11.3496C17.1871 11.3496 17.3667 11.4234 17.499 11.5557L17.5869 11.6631C17.6637 11.7782 17.7051 11.9143 17.7051 12.0547C17.7051 12.1951 17.6637 12.3312 17.5869 12.4463L17.499 12.5537C17.3667 12.686 17.1871 12.7597 17 12.7598H7C6.85962 12.7598 6.72348 12.7184 6.6084 12.6416L6.50098 12.5537C6.36866 12.4214 6.29395 12.2418 6.29395 12.0547C6.29395 11.8676 6.36866 11.688 6.50098 11.5557L6.6084 11.4678C6.72348 11.391 6.85962 11.3496 7 11.3496H17ZM17 6.9043C17.1871 6.90433 17.3667 6.97904 17.499 7.11133L17.5869 7.21875C17.6637 7.33382 17.7051 7.47 17.7051 7.61035C17.7051 7.75073 17.6637 7.88688 17.5869 8.00195L17.499 8.10938C17.3667 8.24167 17.1871 8.3154 17 8.31543H7C6.85964 8.31543 6.72347 8.27401 6.6084 8.19727L6.50098 8.10938C6.36868 7.97708 6.29397 7.79744 6.29395 7.61035C6.29395 7.42323 6.36866 7.24365 6.50098 7.11133L6.6084 7.02344C6.72349 6.94665 6.8596 6.9043 7 6.9043H17Z"
        fill="#0A0A0A"
        stroke="#0A0A0A"
        strokeWidth="0.3"
      />
    </svg>
  );
};

export const EngageProfileVisited = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.66732 6.5V7.16667"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3333 6.5V7.16667"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3327 10.292C8.99576 11.4583 7.00294 11.4583 5.66602 10.292"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.8868 2.51183L13 2.62671L13.1169 2.5031C13.3154 2.29137 13.5918 2.16996 13.8819 2.16705C14.1721 2.16413 14.4509 2.27997 14.6536 2.48767L14.6774 2.51181C15.1075 2.95387 15.1075 3.65806 14.6774 4.10012L13.5078 5.28763C13.3739 5.42372 13.1909 5.50035 13 5.50035C12.809 5.50035 12.6261 5.42372 12.4921 5.28763L11.3226 4.10015C10.8925 3.65809 10.8925 2.95389 11.3226 2.51183C11.5289 2.30227 11.8107 2.18426 12.1047 2.18426C12.3988 2.18426 12.6806 2.30227 12.8868 2.51183Z"
        fill="#6B6A6B"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1706 7.09257C14.8178 9.8596 13.5567 12.7211 11.0776 14.1103C8.59862 15.4995 5.49961 15.0813 3.47744 13.0848C1.45528 11.0882 0.997658 7.99477 2.35515 5.49825C3.71264 3.00173 6.55785 1.70422 9.3329 2.31617"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EngageInterested = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.59958 12.2708H3.39848C2.52546 12.2708 1.81836 11.5637 1.81836 10.6906V3.58012C1.81836 2.7071 2.52546 2 3.39848 2H12.8792C13.7522 2 14.4593 2.7071 14.4593 3.58012V10.6906C14.4593 11.5637 13.7522 12.2708 12.8792 12.2708H10.6781L8.13882 14.81L5.59958 12.2708Z"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.1111 5.55469C9.94699 5.55469 10.5079 6.29023 10.5079 6.97521C10.5079 8.36571 8.18042 9.50498 8.13775 9.50498C8.09509 9.50498 5.76758 8.3665 5.76758 6.97521C5.76758 6.29023 6.32852 5.55469 7.1644 5.55469C7.64239 5.55469 7.95604 5.77827 8.13775 5.97737C8.31947 5.77827 8.63312 5.55469 9.1111 5.55469Z"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EngageFavorite = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 4.30766C8.45933 3.77033 9.254 3.16699 10.464 3.16699C12.5807 3.16699 14 5.15366 14 7.00366C14 10.871 9.18533 13.8337 8 13.8337C6.81467 13.8337 2 10.871 2 7.00366C2 5.15366 3.41933 3.16699 5.536 3.16699C6.746 3.16699 7.54067 3.77033 8 4.30766Z"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EngageContactRequest = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.75369 9.74663C5.97369 8.96663 5.38569 8.0933 4.99502 7.2073C4.91302 7.01996 4.96102 6.80063 5.10569 6.65596L5.65169 6.10996C6.09902 5.66263 6.09902 5.02996 5.70836 4.6393L4.92636 3.8573C4.40569 3.33663 3.56169 3.33663 3.04102 3.8573L2.60636 4.2913C2.11236 4.7853 1.90636 5.49796 2.03969 6.20463C2.36902 7.94663 3.38102 9.85396 5.01369 11.4866C6.64636 13.1193 8.55369 14.1313 10.2957 14.4606C11.0024 14.594 11.715 14.388 12.209 13.894L12.643 13.46C13.1637 12.9393 13.1637 12.0953 12.643 11.5746L11.861 10.7926C11.4704 10.402 10.837 10.402 10.447 10.7926L9.84502 11.3953C9.70036 11.54 9.48102 11.5886 9.29369 11.506C8.40769 11.1146 7.53369 10.526 6.75369 9.74663Z"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5537 2.28094C13.4184 2.28094 13.9991 3.06627 13.9991 3.79827C13.9991 5.28427 11.5897 6.50027 11.5464 6.50027C11.5024 6.50027 9.09375 5.28427 9.09375 3.79827C9.09375 3.06627 9.67442 2.28027 10.5391 2.28027C11.0337 2.28027 11.3584 2.51894 11.5464 2.73161C11.7344 2.51961 12.0591 2.28094 12.5537 2.28094Z"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EngageImageRequest = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.444 1.83301C6.186 1.82968 4.104 3.05168 3.006 5.02501C1.908 6.99835 1.96733 9.41235 3.16067 11.329L2 14.4997L5.17 13.339C7.41267 14.729 10.2887 14.553 12.3447 12.899C14.4007 11.245 15.1893 8.47368 14.312 5.98501C13.4353 3.49568 11.0827 1.83168 8.444 1.83301V1.83301Z"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0026 5.16602H6.66787C5.93119 5.16602 5.33398 5.76322 5.33398 6.4999V9.83463C5.33398 10.5713 5.93119 11.1685 6.66787 11.1685H10.0026C10.7393 11.1685 11.3365 10.5713 11.3365 9.83463V6.4999C11.3365 5.76322 10.7393 5.16602 10.0026 5.16602Z"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.45347 7.04873C7.51847 7.11389 7.51838 7.21938 7.45328 7.28443C7.38817 7.34948 7.28268 7.34948 7.21757 7.28443C7.15247 7.21938 7.15238 7.11389 7.21738 7.04873C7.24866 7.01737 7.29113 6.99974 7.33543 6.99974C7.37972 6.99974 7.42219 7.01737 7.45347 7.04873"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3367 7.86733C11.1987 7.84641 11.0594 7.83527 10.9198 7.83398C9.30833 7.83398 8.00195 9.14036 8.00195 10.7519V10.7519C8.00293 10.8914 8.01407 11.0308 8.0353 11.1687"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PaginationEllipsis = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5683 8.10341H13.576"
        stroke="#151616"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99805 8.10352H8.00405"
        stroke="#151616"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.42378 8.10341H2.43148"
        stroke="#151616"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PaginationNext = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.25 2.5L7.75 6L4.25 9.5"
        stroke="#151616"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PaginationPrev = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.75 9.5L4.25 6L7.75 2.5"
        stroke="#151616"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const GreenTickCircle = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="20" height="20" rx="10" fill="#399647" />
      <path
        d="M6.25 10L8.75 12.5L13.75 7.5"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const WarningIcon = ({ stroke = "#323232" }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 2.5V2.5C14.1425 2.5 17.5 5.8575 17.5 10V10C17.5 14.1425 14.1425 17.5 10 17.5V17.5C5.8575 17.5 2.5 14.1425 2.5 10V10C2.5 5.8575 5.8575 2.5 10 2.5Z"
        stroke={stroke}
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.99992 10.4167V6.25"
        stroke={stroke}
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.99909 13.3333C9.88409 13.3333 9.79075 13.4267 9.79159 13.5417C9.79159 13.6567 9.88492 13.75 9.99992 13.75C10.1149 13.75 10.2083 13.6567 10.2083 13.5417C10.2083 13.4267 10.1149 13.3333 9.99909 13.3333"
        stroke={stroke}
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const CopyClipBoardBlack = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g mask="url(#mask0_2632_35722)">
        <path
          d="M9.5 18.5C8.95 18.5 8.47917 18.3042 8.0875 17.9125C7.69583 17.5208 7.5 17.05 7.5 16.5V4.5C7.5 3.95 7.69583 3.47917 8.0875 3.0875C8.47917 2.69583 8.95 2.5 9.5 2.5H18.5C19.05 2.5 19.5208 2.69583 19.9125 3.0875C20.3042 3.47917 20.5 3.95 20.5 4.5V16.5C20.5 17.05 20.3042 17.5208 19.9125 17.9125C19.5208 18.3042 19.05 18.5 18.5 18.5H9.5ZM9.5 16.5H18.5V4.5H9.5V16.5ZM5.5 22.5C4.95 22.5 4.47917 22.3042 4.0875 21.9125C3.69583 21.5208 3.5 21.05 3.5 20.5V6.5H5.5V20.5H16.5V22.5H5.5Z"
          fill="#1C1B1F"
        />
      </g>
    </svg>
  );
};

export const DeleteIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.3619 14.5021H5.63798C4.85386 14.5021 4.20192 13.8984 4.14178 13.1166L3.49805 4.74805H12.5018L11.8581 13.1166C11.7979 13.8984 11.146 14.5021 10.3619 14.5021V14.5021Z"
        stroke="#D1473E"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3361 4.74753H2.66504"
        stroke="#D1473E"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.12434 2.49609H9.8759C10.2903 2.49609 10.6262 2.83202 10.6262 3.24641V4.74703H5.37402V3.24641C5.37402 2.83202 5.70995 2.49609 6.12434 2.49609Z"
        stroke="#D1473E"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.31394 7.75V11.5016"
        stroke="#D1473E"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.68699 7.75V11.5016"
        stroke="#D1473E"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SettingsSecurity = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.01842 7.91667V7.018C9.01842 6.456 8.56242 6 8.00042 6V6C7.43842 6 6.98242 6.456 6.98242 7.018V7.91667"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.16699 7.91797H6.83366C6.46566 7.91797 6.16699 8.21664 6.16699 8.58464V10.0006C6.16699 10.3686 6.46566 10.6673 6.83366 10.6673H9.16699C9.53499 10.6673 9.83366 10.3686 9.83366 10.0006V8.58464C9.83366 8.21664 9.53499 7.91797 9.16699 7.91797Z"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.3337 7.9945C13.3337 10.9065 11.229 13.6358 8.34699 14.4518C8.12166 14.5158 7.87899 14.5158 7.65366 14.4518C4.77166 13.6365 2.66699 10.9065 2.66699 7.9945V5.30917C2.66699 4.76783 2.99433 4.27983 3.49566 4.07517L6.73833 2.7485C7.54766 2.41717 8.45433 2.41717 9.26299 2.7485L12.5057 4.07517C13.0063 4.27983 13.3337 4.76783 13.3337 5.30917V7.9945Z"
        stroke="#6B6A6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LogoutIconCircle = () => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="32" cy="32" r="28" fill="#672666" fillOpacity="0.1" />
      <circle cx="32" cy="32" r="31.5" stroke="#672666" strokeOpacity="0.3" />
      <path
        d="M34.8533 31.9997H21.3333"
        stroke="#672666"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.5147 42.641L39.072 42.6663C40.6654 42.6743 41.9614 41.397 41.9614 39.8197V24.1797C41.9614 22.6077 40.6747 21.333 39.0854 21.333H33.3334"
        stroke="#672666"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.6667 37.3337L21.3334 32.0003L26.6667 26.667"
        stroke="#672666"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DeleteIconCircle = () => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="32" cy="32" r="28" fill="#DA2828" fillOpacity="0.1" />
      <circle cx="32" cy="32" r="31.5" stroke="#DA2828" strokeOpacity="0.3" />
      <path
        d="M40 24V41C40 42.6573 38.6307 44 36.9747 44H26.9747C25.3173 44 24 42.6573 24 41V24"
        stroke="#DA2828"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42 24.0007H22"
        stroke="#DA2828"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.333 20.0007H34.6663"
        stroke="#DA2828"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.6667 29.334V38.6673"
        stroke="#DA2828"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.3337 38.6673V29.334"
        stroke="#DA2828"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DatePickerIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.24887 2.49805V4.99909"
        stroke="#4D4C4D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7518 2.49805V4.99909"
        stroke="#4D4C4D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.49707 7.91684H17.5033"
        stroke="#4D4C4D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="2.49707"
        y="3.74805"
        width="15.0062"
        height="13.7557"
        rx="3"
        stroke="#4D4C4D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PlusIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 7H1"
        stroke="#0A0A0A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 13V1"
        stroke="#0A0A0A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const StarIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.3043 4.59297L20.6509 9.32497C20.9709 9.98364 21.8243 10.6156 22.5443 10.7356L26.7963 11.449C29.5163 11.9063 30.1563 13.8956 28.1963 15.8583L24.8896 19.1916C24.3296 19.7556 24.0229 20.845 24.1963 21.625L25.1429 25.7516C25.8896 29.0183 24.1696 30.281 21.3029 28.5743L17.3163 26.1943C16.5963 25.765 15.4096 25.765 14.6763 26.1943L10.6923 28.5743C7.83892 30.281 6.10559 29.0036 6.85226 25.7516L7.79892 21.625C7.97226 20.845 7.66559 19.7556 7.10559 19.1916L3.79892 15.8583C1.85359 13.8943 2.48026 11.9063 5.19892 11.449L9.45226 10.7356C10.1589 10.6156 11.0123 9.98364 11.3323 9.32497L13.6789 4.59297C14.9589 2.0263 17.0389 2.0263 18.3056 4.59297"
        stroke="#8C8B8C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ReferShareIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.57596 13.479C4.91955 14.1354 4.55078 15.0257 4.55078 15.954C4.55078 16.8823 4.91955 17.7726 5.57596 18.429C6.23237 19.0854 7.12265 19.4542 8.05096 19.4542C8.97926 19.4542 9.86955 19.0854 10.526 18.429M12.999 11.006C13.324 11.331 13.5818 11.7169 13.7578 12.1415C13.9337 12.5662 14.0242 13.0214 14.0242 13.481C14.0242 13.9407 13.9337 14.3958 13.7578 14.8205C13.5818 15.2451 13.324 15.631 12.999 15.956L10.524 18.431M8.04896 11.006L5.57396 13.481M18.431 10.524C19.0874 9.8676 19.4561 8.97731 19.4561 8.04901C19.4561 7.1207 19.0874 6.23042 18.431 5.57401C17.7745 4.9176 16.8843 4.54883 15.956 4.54883C15.0277 4.54883 14.1374 4.9176 13.481 5.57401M11.01 12.998C10.6849 12.673 10.4271 12.2871 10.2512 11.8625C10.0752 11.4378 9.98471 10.9827 9.98471 10.523C9.98471 10.0633 10.0752 9.6082 10.2512 9.18353C10.4271 8.75887 10.6849 8.37302 11.01 8.04801L13.484 5.57301M15.958 12.998L18.433 10.523"
        stroke="#FFF5FF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const FriendSignUp = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 11.9977H15.1987M15.1987 11.9977L12.399 9.59766M15.1987 11.9977L12.399 14.3977"
        stroke="#FFF5FF"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.60352 7.99805C9.61311 6.25805 9.69071 5.31565 10.305 4.70125C11.0081 3.99805 12.1392 3.99805 14.4013 3.99805H15.2013C17.4642 3.99805 18.5952 3.99805 19.2984 4.70125C20.0007 5.40365 20.0007 6.53565 20.0007 8.79805V15.198C20.0007 17.4604 20.0007 18.5924 19.2984 19.2948C18.5944 19.998 17.4642 19.998 15.2013 19.998H14.4013C12.1392 19.998 11.0081 19.998 10.305 19.2948C9.69071 18.6804 9.61311 17.738 9.60352 15.998"
        stroke="#FFF5FF"
        strokeWidth="1.3"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const EarnReward = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 10.998V18.998C4 19.5285 4.21071 20.0372 4.58579 20.4123C4.96086 20.7873 5.46957 20.998 6 20.998H18C18.5304 20.998 19.0391 20.7873 19.4142 20.4123C19.7893 20.0372 20 19.5285 20 18.998V10.998"
        stroke="#F9F7F9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 5.49805C12 4.56979 11.6313 3.67955 10.9749 3.02317C10.3185 2.3668 9.42826 1.99805 8.5 1.99805C7.83696 1.99805 7.20107 2.26144 6.73223 2.73028C6.26339 3.19912 6 3.83501 6 4.49805C6 5.16109 6.26339 5.79697 6.73223 6.26581C7.20107 6.73465 7.83696 6.99805 8.5 6.99805H12M12 5.49805V6.99805M12 5.49805C12 4.56979 12.3687 3.67955 13.0251 3.02317C13.6815 2.3668 14.5717 1.99805 15.5 1.99805C16.163 1.99805 16.7989 2.26144 17.2678 2.73028C17.7366 3.19912 18 3.83501 18 4.49805C18 4.82635 17.9353 5.15144 17.8097 5.45476C17.6841 5.75807 17.4999 6.03367 17.2678 6.26581C17.0356 6.49796 16.76 6.68211 16.4567 6.80775C16.1534 6.93338 15.8283 6.99805 15.5 6.99805H12"
        stroke="#F9F7F9"
        strokeLinejoin="round"
      />
      <path
        d="M12 10.998V20.998M3 6.99805H21V10.998H3V6.99805Z"
        stroke="#F9F7F9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SaveIcon = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g mask="url(#mask0_1994_25814)">
        <path
          d="M7.95817 13.833L3.229 9.10384L4.4165 7.91634L7.95817 11.458L15.5832 3.83301L16.7707 5.02051L7.95817 13.833ZM4.1665 17.1663V15.4997H15.8332V17.1663H4.1665Z"
          fill="#8C8B8C"
        />
      </g>
    </svg>
  );
};

export const CreatedBy = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.85226 10.4142L10.4132 4.85324C10.7521 4.51443 10.7521 3.96553 10.4132 3.62739L9.038 2.25215C8.6992 1.91334 8.1503 1.91334 7.81216 2.25215L2.25118 7.81314C2.08777 7.97654 1.99707 8.19663 1.99707 8.42606V10.6683H4.23934C4.46877 10.6683 4.68886 10.5776 4.85226 10.4142Z"
        stroke="#0A0A0A"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99957 10.6685H12.3347C13.2558 10.6685 14.0021 11.4148 14.0021 12.3358V12.3358C14.0021 13.2569 13.2558 14.0032 12.3347 14.0032H1.99707"
        stroke="#0A0A0A"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UploadArrowIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5 12.5V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V12.5M14.1667 6.66667L10 2.5M10 2.5L5.83333 6.66667M10 2.5V12.5"
        stroke="#672666"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PurpleCircleTick = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="16" height="16" rx="8" fill="#DEB0DD" />
      <path
        d="M5 8L7 10L11 6"
        stroke="#672666"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const StandardPlan = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.61889 17.4126V17.4126C5.77114 16.6431 3.00146 13.2646 3.00146 9.34066V6.66667C3.00146 4.36548 4.86694 2.5 7.16813 2.5H13.8348C16.136 2.5 18.0015 4.36548 18.0015 6.66667V9.34063C18.0015 13.2645 15.2319 16.6429 11.3842 17.4126H11.384C10.8014 17.5291 10.2015 17.5291 9.61889 17.4126V17.4126Z"
        stroke="#672666"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.1638 7.08594L8.83545 9.58594H12.1688L10.8404 12.0859"
        stroke="#672666"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PlansClose = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.501465" width="20" height="20" rx="10" fill="#ECE6EC" />
      <path
        d="M13.5015 7L7.50146 13"
        stroke="#672666"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5015 13L7.50146 7"
        stroke="#672666"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PlansTick = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.501465" width="20" height="20" rx="10" fill="#963994" />
      <path
        d="M6.75146 10L9.25146 12.5L14.2515 7.5"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DislikePost = ({ stroke = "#0A0A0A", fill = "none" }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.33366 9.66778V11.6495C9.33366 12.6468 8.69983 13.5339 7.75633 13.857L7.49633 13.9461C7.24435 14.0324 6.96836 14.0146 6.72954 13.8966C6.49073 13.7787 6.30883 13.5704 6.22418 13.3178L5.00033 9.66696H2.62533C2.09605 9.66696 1.66699 9.2379 1.66699 8.70863V2.95863C1.66699 2.42936 2.09605 2.0003 2.62533 2.0003H11.4577C12.3372 2.0003 13.1038 2.59887 13.3172 3.4521L14.2755 7.28544C14.4186 7.85802 14.29 8.46463 13.9268 8.92984C13.5636 9.39504 13.0063 9.66696 12.416 9.66696H9.33366"
        stroke={stroke}
        fill={fill}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.00033 1.9974V9.66406"
        stroke={stroke}
        fill={fill}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PostComments = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6 14.001L9.33333 11.3203"
        stroke="#0A0A0A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.99935 11.3359V14.0026"
        stroke="#0A0A0A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 11.3333H5.33333C3.49267 11.3333 2 9.84067 2 8V5.33333C2 3.49267 3.49267 2 5.33333 2H10.6667C12.5073 2 14 3.49267 14 5.33333V8C14 9.84067 12.5073 11.3333 10.6667 11.3333H9.33333"
        stroke="#0A0A0A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SavePost = ({ stroke = "#0A0A0A", fill = "none" }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.3332 4V13.3321C13.3332 13.5846 13.1905 13.8154 12.9647 13.9283C12.7389 14.0413 12.4686 14.017 12.2666 13.8655L7.99984 10.6667L3.73307 13.8655C3.53105 14.017 3.2608 14.0413 3.03497 13.9283C2.80915 13.8154 2.6665 13.5846 2.6665 13.3321V4C2.6665 2.89543 3.56193 2 4.6665 2H11.3332C12.4377 2 13.3332 2.89543 13.3332 4Z"
        stroke={stroke}
        fill={fill}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const Seperator = () => {
  return (
    <svg
      width="2"
      height="16"
      viewBox="0 0 2 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1="0.681641"
        y1="16"
        x2="0.68164"
        y2="2.18557e-08"
        stroke="#D9D7D9"
      />
    </svg>
  );
};

export const LikePost = ({ stroke = "#0A0A0A", fill = "none" }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.33366 6.33222V4.35046C9.33366 3.35316 8.69983 2.46611 7.75633 2.14299L7.49633 2.05394C7.24435 1.96765 6.96836 1.98544 6.72954 2.10337C6.49073 2.2213 6.30883 2.42963 6.22418 2.68216L5.00033 6.33304H2.62533C2.09605 6.33304 1.66699 6.7621 1.66699 7.29137V13.0414C1.66699 13.5706 2.09605 13.9997 2.62533 13.9997H11.4577C12.3372 13.9997 13.1038 13.4011 13.3172 12.5479L14.2755 8.71456C14.4186 8.14198 14.29 7.53537 13.9268 7.07016C13.5636 6.60496 13.0063 6.33304 12.416 6.33304H9.33366"
        stroke={stroke}
        fill={fill}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.00033 14.0026V6.33594"
        stroke={stroke}
        fill={fill}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Options = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9318 18.2395C11.987 18.2396 12.0317 18.2798 12.0316 18.3293C12.0316 18.3788 11.9869 18.419 11.9317 18.419C11.8765 18.419 11.8317 18.3789 11.8316 18.3294C11.8316 18.3056 11.8421 18.2827 11.8609 18.2658C11.8797 18.249 11.9052 18.2395 11.9318 18.2395"
        stroke="#0A0A0A"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9318 5.67705C11.987 5.67711 12.0317 5.71728 12.0316 5.76681C12.0316 5.81634 11.9869 5.85648 11.9317 5.8565C11.8765 5.85652 11.8317 5.81641 11.8316 5.76688C11.8316 5.74305 11.8421 5.72018 11.8609 5.70333C11.8797 5.68647 11.9052 5.67702 11.9318 5.67705"
        stroke="#0A0A0A"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9318 11.9583C11.987 11.9584 12.0317 11.9985 12.0316 12.0481C12.0316 12.0976 11.9869 12.1377 11.9317 12.1378C11.8765 12.1378 11.8317 12.0977 11.8316 12.0481C11.8316 12.0243 11.8421 12.0014 11.8609 11.9846C11.8797 11.9677 11.9052 11.9583 11.9318 11.9583"
        stroke="#0A0A0A"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Filter = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.66602 5.33203L4.66602 3.33203L2.66602 5.33203"
        stroke="#323232"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.66634 12.6654V3.33203"
        stroke="#323232"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.33301 10.6641L11.333 12.6641L13.333 10.6641"
        stroke="#323232"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3324 3.33203V12.6654"
        stroke="#323232"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const CopyClipBoard = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 22.5C4.45 22.5 3.979 22.3043 3.587 21.913C3.19567 21.521 3 21.05 3 20.5V6.5H5V20.5H16V22.5H5ZM9 18.5C8.45 18.5 7.97933 18.3043 7.588 17.913C7.196 17.521 7 17.05 7 16.5V4.5C7 3.95 7.196 3.479 7.588 3.087C7.97933 2.69567 8.45 2.5 9 2.5H18C18.55 2.5 19.021 2.69567 19.413 3.087C19.8043 3.479 20 3.95 20 4.5V16.5C20 17.05 19.8043 17.521 19.413 17.913C19.021 18.3043 18.55 18.5 18 18.5H9Z"
        fill="#672666"
      />
    </svg>
  );
};

export const ConnectChat = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.0863 11.9427C1.30101 9.39461 1.75969 5.90458 4.14275 3.90433C6.52581 1.90407 10.0425 2.05731 12.2426 4.25726C14.4426 6.45721 14.596 9.97391 12.5958 12.357C10.5957 14.7402 7.10565 15.199 4.55749 13.4138L2.66598 13.8341L3.0863 11.9427Z"
        stroke="#4D4C4D"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.84893 7.10531L7.99967 7.25837L8.15043 7.10529C8.42472 6.82498 8.80037 6.66699 9.19255 6.66699C9.58473 6.66699 9.96038 6.82498 10.2347 7.10529V7.10529C10.8102 7.69334 10.8102 8.63357 10.2347 9.22162L8.82461 10.6534C8.60748 10.8753 8.31011 11.0003 7.99966 11.0003C7.6892 11.0003 7.39183 10.8753 7.1747 10.6534L5.76467 9.22166C5.18912 8.6336 5.18912 7.69337 5.76467 7.10532V7.10532C6.03896 6.825 6.41461 6.66701 6.8068 6.66701C7.19899 6.66701 7.57464 6.825 7.84893 7.10531Z"
        stroke="#4D4C4D"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ConnectCall = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.69869 9.74565C5.91869 8.96565 5.33069 8.09232 4.94003 7.20632C4.85736 7.01899 4.90603 6.79965 5.05069 6.65499L5.59669 6.10899C6.04403 5.66165 6.04403 5.02899 5.65336 4.63832L4.87069 3.85632C4.35003 3.33565 3.50603 3.33565 2.98536 3.85632L2.55069 4.29032C2.05669 4.78432 1.85069 5.49699 1.98403 6.20365C2.31336 7.94565 3.32536 9.85299 4.95803 11.4857C6.59069 13.1183 8.49803 14.1303 10.24 14.4597C10.9467 14.593 11.6594 14.387 12.1534 13.893L12.5874 13.459C13.108 12.9383 13.108 12.0943 12.5874 11.5737L11.8054 10.7917C11.4147 10.401 10.7814 10.401 10.3914 10.7917L9.78936 11.3943C9.64469 11.539 9.42536 11.5877 9.23803 11.505C8.35203 11.1137 7.47869 10.525 6.69869 9.74565Z"
        stroke="#4D4C4D"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.61361 3.94672V2.38672"
        stroke="#4D4C4D"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3936 5.04646L12.4936 3.95312"
        stroke="#4D4C4D"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 7.83333H14.0533"
        stroke="#4D4C4D"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ConnectRequest = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.338 12.5H12C13.1046 12.5 14 11.6046 14 10.5V4.5C14 3.39543 13.1046 2.5 12 2.5H4C2.89543 2.5 2 3.39543 2 4.5V10.5C2 11.6046 2.89543 12.5 4 12.5H5.338V14.1286C5.338 14.2711 5.41969 14.401 5.54813 14.4627C5.67658 14.5245 5.82904 14.5071 5.94033 14.4181L8.338 12.5Z"
        stroke="#4D4C4D"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.84893 6.10531L7.99967 6.25837L8.15043 6.10529C8.42472 5.82498 8.80037 5.66699 9.19255 5.66699C9.58473 5.66699 9.96038 5.82498 10.2347 6.10529V6.10529C10.8102 6.69334 10.8102 7.63357 10.2347 8.22162L8.82461 9.65336C8.60748 9.87526 8.31011 10.0003 7.99966 10.0003C7.6892 10.0003 7.39183 9.87526 7.1747 9.65336L5.76467 8.22166C5.18912 7.6336 5.18912 6.69337 5.76467 6.10532V6.10532C6.03896 5.825 6.41461 5.66701 6.8068 5.66701C7.19899 5.66701 7.57464 5.825 7.84893 6.10531V6.10531Z"
        stroke="#4D4C4D"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const FavouriteFill = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4667 2.66699C12.58 2.66699 14 4.65366 14 6.50699C14 10.2603 8.10667 13.3337 8 13.3337C7.89333 13.3337 2 10.2603 2 6.50699C2 4.65366 3.42 2.66699 5.53333 2.66699C6.74667 2.66699 7.54 3.27366 8 3.80699C8.46 3.27366 9.25333 2.66699 10.4667 2.66699Z"
        fill="#EB2B33"
        stroke="#EB2B33"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ConnectVideoCall = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3335 8.57706L16.2295 6.79194C16.4866 6.63344 16.8093 6.62646 17.073 6.77368C17.3368 6.92091 17.5002 7.1993 17.5002 7.50132V13.332C17.5002 13.634 17.3368 13.9124 17.0731 14.0596C16.8094 14.2068 16.4867 14.1999 16.2296 14.0414L13.3335 12.2562"
        stroke="#0A0A0A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="2.5"
        y="5"
        width="10.8333"
        height="10.8333"
        rx="3"
        stroke="#0A0A0A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ConnectAudioIncoming = ({ stroke = "#0A0A0A" }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.44211 11.5666C7.46711 10.5916 6.73211 9.49992 6.24378 8.39242C6.14128 8.15826 6.20128 7.88409 6.38211 7.70326L7.06461 7.02076C7.62378 6.46159 7.62378 5.67076 7.13545 5.18242L6.15795 4.20492C5.50711 3.55409 4.45211 3.55409 3.80128 4.20492L3.25795 4.74742C2.64045 5.36492 2.38295 6.25576 2.54961 7.13909C2.96128 9.31659 4.22628 11.7008 6.26711 13.7416C8.30795 15.7824 10.6921 17.0474 12.8696 17.4591C13.7529 17.6258 14.6438 17.3683 15.2613 16.7508L15.8038 16.2083C16.4546 15.5574 16.4546 14.5024 15.8038 13.8516L14.8263 12.8741C14.3379 12.3858 13.5463 12.3858 13.0588 12.8741L12.3063 13.6274C12.1254 13.8083 11.8513 13.8691 11.6171 13.7658C10.5096 13.2766 9.41711 12.5408 8.44211 11.5666Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 2.5V7.5H17.5"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 2.5L12.5 7.5"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ConnectAudioOutgoing = ({ stroke = "#0A0A0A" }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.44211 11.5578C7.46711 10.5828 6.73211 9.49113 6.24378 8.38363C6.14128 8.14947 6.20128 7.8753 6.38211 7.69447L7.06461 7.01197C7.62378 6.4528 7.62378 5.66197 7.13545 5.17363L6.15795 4.19613C5.50711 3.5453 4.45211 3.5453 3.80128 4.19613L3.25795 4.73863C2.64045 5.35613 2.38295 6.24697 2.54961 7.1303C2.96128 9.3078 4.22628 11.692 6.26711 13.7328C8.30795 15.7736 10.6921 17.0386 12.8696 17.4503C13.7529 17.617 14.6438 17.3595 15.2613 16.742L15.8038 16.1995C16.4546 15.5486 16.4546 14.4936 15.8038 13.8428L14.8263 12.8653C14.3379 12.377 13.5463 12.377 13.0588 12.8653L12.3063 13.6186C12.1254 13.7995 11.8513 13.8603 11.6171 13.757C10.5096 13.2678 9.41711 12.532 8.44211 11.5578Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 7.5V2.5H12.5"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 7.5L17.5 2.5"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ConnectClock = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.44967 4.67525C10.851 3.26642 14.7504 4.88163 16.1592 8.28293C17.568 11.6842 15.9528 15.5836 12.5515 16.9925C9.15022 18.4013 5.25083 16.7861 3.84199 13.3848C2.43315 9.98348 4.04837 6.08409 7.44967 4.67525"
        stroke="#4D4C4D"
        strokeWidth="1.50004"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.875 4.84121L5.375 2.74121"
        stroke="#4D4C4D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.1333 4.85L14.6333 2.75"
        stroke="#4D4C4D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.79199 7.86035V11.3062L12.5003 12.9579"
        stroke="#4D4C4D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ArrowRightIcon = ({ stroke = "white" }) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.875 5.86328L2.375 5.86328"
        stroke={stroke}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.8501 2.8505L9.8751 5.8625L6.8501 8.875"
        stroke={stroke}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ArrowLeftIcon = ({ stroke = "white" }) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.125 6.13672L9.625 6.13672"
        stroke={stroke}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.1499 9.1495L2.1249 6.1375L5.1499 3.125"
        stroke={stroke}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PhoneIcon = ({ stroke = "#323232" }) => {
  return (
    <svg
      width="23"
      height="22"
      viewBox="0 0 23 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.1329 12.0488C9.06045 10.9763 8.25195 9.7755 7.71478 8.55725C7.60111 8.29967 7.66803 7.99808 7.86694 7.79917L8.6177 7.04933C9.23278 6.43425 9.23278 5.56433 8.69561 5.02717L7.61944 3.951C6.90353 3.23508 5.74303 3.23508 5.02711 3.951L4.42944 4.54867C3.75019 5.22792 3.46694 6.20783 3.65028 7.1795C4.10311 9.57475 5.49461 12.1973 7.73953 14.4423C9.98445 16.6872 12.607 18.0787 15.0023 18.5315C15.9739 18.7148 16.9539 18.4316 17.6331 17.7523L18.2299 17.1556C18.9458 16.4397 18.9458 15.2792 18.2299 14.5633L17.1546 13.488C16.6174 12.9508 15.7466 12.9508 15.2104 13.488L14.3826 14.3167C14.1837 14.5156 13.8821 14.5825 13.6245 14.4688C12.4063 13.9307 11.2054 13.1213 10.1329 12.0488Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LinkIcon = ({ stroke = "#4D4C4D" }) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.6594 13.9621L18.8513 11.7702C20.592 9.98563 20.5742 7.13318 18.8114 5.37043C17.0487 3.60768 14.1962 3.5899 12.4116 5.33054L10.2197 7.52245"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.8499 9.33203L9.51367 14.6683"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.7036 10.0381L5.51169 12.23C3.77105 14.0146 3.78883 16.867 5.55158 18.6298C7.31433 20.3925 10.1668 20.4103 11.9514 18.6697L14.1433 16.4778"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const MessageSendIcon = ({ fill = "white", background = "#672666" }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="18"
        height="18"
        transform="translate(0.181641)"
        fill={background}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6134 8.46113L3.33967 2.29945C2.78855 2.12408 2.26259 2.42465 2.3878 3.05094L4.14117 7.7601L9.63709 8.65779C10.0139 8.71934 10.0148 9.26101 9.63817 9.32378L4.14117 10.24L2.3878 14.9491C2.2626 15.5753 2.78855 15.8758 3.33967 15.7006L15.6134 9.51393C16.1144 9.31355 16.1144 8.6867 15.6134 8.46113Z"
        fill={fill}
      />
    </svg>
  );
};

export const EmojiIcon = ({ stroke = "#4D4C4D", fill = "#4D4C4D" }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 21C5.477 21 1 16.523 1 11C1 5.477 5.477 1 11 1C16.523 1 21 5.477 21 11C21 16.523 16.523 21 11 21Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5 13.5C15.5 13.5 14 15.5 11 15.5C8 15.5 6.5 13.5 6.5 13.5"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5 9C14.3674 9 14.2402 8.94732 14.1464 8.85355C14.0527 8.75979 14 8.63261 14 8.5C14 8.36739 14.0527 8.24021 14.1464 8.14645C14.2402 8.05268 14.3674 8 14.5 8C14.6326 8 14.7598 8.05268 14.8536 8.14645C14.9473 8.24021 15 8.36739 15 8.5C15 8.63261 14.9473 8.75979 14.8536 8.85355C14.7598 8.94732 14.6326 9 14.5 9ZM7.5 9C7.36739 9 7.24021 8.94732 7.14645 8.85355C7.05268 8.75979 7 8.63261 7 8.5C7 8.36739 7.05268 8.24021 7.14645 8.14645C7.24021 8.05268 7.36739 8 7.5 8C7.63261 8 7.75979 8.05268 7.85355 8.14645C7.94732 8.24021 8 8.36739 8 8.5C8 8.63261 7.94732 8.75979 7.85355 8.85355C7.75979 8.94732 7.63261 9 7.5 9Z"
        fill={fill}
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const AskMeIcon = ({ stroke = "#4D4C4D" }) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.86621 9.68482C10.1032 8.66326 11.0337 7.95496 12.0815 7.99844C13.2541 7.93349 14.2594 8.82709 14.3324 9.99928C14.3324 11.5038 12.1815 12.0001 12.1815 13.0005"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.3069 15.7518C12.3068 15.8209 12.2508 15.8768 12.1818 15.8767C12.1128 15.8767 12.0568 15.8207 12.0568 15.7517C12.0568 15.6827 12.1127 15.6267 12.1817 15.6266C12.2149 15.6266 12.2468 15.6398 12.2703 15.6632C12.2938 15.6867 12.3069 15.7186 12.3069 15.7518"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.81025 17.1605C2.12715 13.3308 2.81666 8.08546 6.39836 5.07926C9.98006 2.07305 15.2655 2.30347 18.572 5.60997C21.8785 8.91646 22.1089 14.2019 19.1027 17.7836C16.0965 21.3653 10.8512 22.0548 7.02144 19.3717L4.17852 20.0034L4.81025 17.1605Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const InvertedInfoIcon = ({ stroke = "#4D4C4D" }) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1816 3V3C17.1526 3 21.1816 7.029 21.1816 12V12C21.1816 16.971 17.1526 21 12.1816 21V21C7.21064 21 3.18164 16.971 3.18164 12V12C3.18164 7.029 7.21064 3 12.1816 3Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.1816 12.5V7.5"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.1806 16C12.0426 16 11.9306 16.112 11.9316 16.25C11.9316 16.388 12.0436 16.5 12.1816 16.5C12.3196 16.5 12.4316 16.388 12.4316 16.25C12.4316 16.112 12.3196 16 12.1806 16"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const BlockIcon = ({ stroke = "#4D4C4D" }) => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.1677 4.69629L5.56104 15.303L16.1677 4.69629Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8638 2.5C6.72127 2.5 3.36377 5.8575 3.36377 10C3.36377 14.1425 6.72127 17.5 10.8638 17.5C15.0063 17.5 18.3638 14.1425 18.3638 10C18.3638 5.8575 15.0063 2.5 10.8638 2.5Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const RemoveSelectIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 3L3 9M3 3L9 9"
        stroke="#0A0A0A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CloseIconCircle = () => {
  return (
    <svg
      width="104"
      height="104"
      viewBox="0 0 104 104"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_dd_13379_24323)">
        <circle cx="52" cy="52" r="36" fill="#F9F7F9" />
        <circle
          cx="52"
          cy="52"
          r="36.9739"
          stroke="#B97AB7"
          strokeWidth="1.94787"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M65.1291 41.9872L42.2736 64.7923C42.2736 64.7923 40.7492 66.293 38.7501 64.7926C37.2492 63.293 38.7492 61.2817 38.7492 61.2817L61.6451 38.5033C62.7483 37.2927 64.2444 37.6144 65.1291 38.4983C65.986 39.3544 66.2483 40.7876 65.1291 41.9872Z"
        fill="#963994"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M42.3591 38.6646L65.1642 61.5201C65.1642 61.5201 66.6648 63.0445 65.1644 65.0436C63.6648 66.5445 61.6535 65.0445 61.6535 65.0445L38.8751 42.1486C37.6646 41.0454 37.9862 39.5493 38.8701 38.6646C39.7263 37.8077 41.1594 37.5454 42.3591 38.6646Z"
        fill="#963994"
      />
      <defs>
        <filter
          id="filter0_dd_13379_24323"
          x="3.82386"
          y="3.82239"
          width="96.3523"
          height="96.3552"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="3.89574"
            operator="dilate"
            in="SourceAlpha"
            result="effect1_dropShadow_13379_24323"
          />
          <feOffset />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.870588 0 0 0 0 0.690196 0 0 0 0 0.866667 0 0 0 0.62 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_13379_24323"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="10.2284"
            operator="dilate"
            in="SourceAlpha"
            result="effect2_dropShadow_13379_24323"
          />
          <feOffset />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.870588 0 0 0 0 0.690196 0 0 0 0 0.866667 0 0 0 0.19 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_13379_24323"
            result="effect2_dropShadow_13379_24323"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_13379_24323"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const HomeIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.734 9.764L12.002 3L20.267 9.764C20.731 10.143 21 10.712 21 11.311V19C21 20.105 20.105 21 19 21H5C3.895 21 3 20.105 3 19V11.312C3 10.712 3.269 10.143 3.734 9.764V9.764Z"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ExploreIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="11.998"
        cy="11.998"
        r="10"
        stroke="#0A0A0A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.44573 15.891L8.7124 9.57763C8.80064 9.13781 9.1447 8.7942 9.58462 8.70652L15.898 7.44429C16.08 7.40806 16.268 7.4651 16.3993 7.59632C16.5305 7.72754 16.5875 7.91562 16.5513 8.09763L15.2891 14.411C15.201 14.8505 14.8575 15.194 14.418 15.2821L8.10462 16.5499C7.92062 16.5889 7.72934 16.5323 7.59632 16.3993C7.46331 16.2662 7.40664 16.075 7.44573 15.891Z"
        stroke="#0A0A0A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="11.9961" cy="11.9961" r="0.652344" stroke="#0A0A0A" />
    </svg>
  );
};

export const EngageIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 19.9996C5 17.4996 7 15.5996 9.4 15.5996H14.5C17 15.5996 18.9 17.5996 18.9 19.9996"
        stroke="#0A0A0A"
        strokeWidth="1.4824"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.9995 5.2C16.6995 6.9 16.6995 9.6 14.9995 11.2C13.2995 12.8 10.5995 12.9 8.9995 11.2C7.3995 9.5 7.2995 6.8 8.9995 5.2C10.6995 3.6 13.2995 3.6 14.9995 5.2"
        stroke="#0A0A0A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ConnectIcon = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.64505 8.52621H1.9082"
        stroke="#0A0A0A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.64505 15.4735H1.9082"
        stroke="#0A0A0A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.0658 11.9989H0.75"
        stroke="#0A0A0A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.96094 4.63069C7.94135 1.65029 12.4236 0.758702 16.3177 2.37169C20.2118 3.98467 22.7508 7.78458 22.7508 11.9995C22.7508 16.2144 20.2118 20.0143 16.3177 21.6273C12.4236 23.2403 7.94135 22.3487 4.96094 19.3683"
        stroke="#0A0A0A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.067 9.57574L12.3289 9.84159L12.5907 9.57571C13.0671 9.08886 13.7195 8.81445 14.4007 8.81445C15.0819 8.81445 15.7343 9.08886 16.2107 9.57571V9.57571C17.2103 10.5971 17.2103 12.2301 16.2107 13.2514L13.7616 15.7382C13.3845 16.1236 12.868 16.3408 12.3288 16.3408C11.7896 16.3408 11.2731 16.1236 10.896 15.7382L8.447 13.2515C7.44735 12.2301 7.44735 10.5971 8.447 9.57574V9.57574C8.92341 9.08889 9.57585 8.81447 10.257 8.81447C10.9382 8.81447 11.5906 9.08889 12.067 9.57574Z"
        stroke="#0A0A0A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const DisableIcon = () => {
  return (<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M15.3039 4.69629L4.69727 15.303L15.3039 4.69629Z" stroke="#4D4C4D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M10 2.5C5.8575 2.5 2.5 5.8575 2.5 10C2.5 14.1425 5.8575 17.5 10 17.5C14.1425 17.5 17.5 14.1425 17.5 10C17.5 5.8575 14.1425 2.5 10 2.5Z" stroke="#4D4C4D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
  )
}